// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/woff2/latin.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* latin */
@font-face {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 100;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304,
    U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin */
@font-face {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304,
    U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin */
@font-face {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304,
    U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin */
@font-face {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304,
    U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin */
@font-face {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304,
    U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* ! tailwindcss v3.2.4 | MIT License | https://tailwindcss.com */
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  -webkit-box-sizing: border-box;
          box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e2e8f0; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
*/
html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  -moz-tab-size: 4;
    -o-tab-size: 4;
       tab-size: 4; /* 3 */
  font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  -webkit-font-feature-settings: normal;
          font-feature-settings: normal; /* 5 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted currentColor;
          text-decoration: underline dotted currentColor;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
  opacity: 1; /* 1 */
  color: #cbd5e0; /* 2 */
}
input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #cbd5e0; /* 2 */
}
input:-ms-input-placeholder, textarea:-ms-input-placeholder {
  opacity: 1; /* 1 */
  color: #cbd5e0; /* 2 */
}
input::-ms-input-placeholder, textarea::-ms-input-placeholder {
  opacity: 1; /* 1 */
  color: #cbd5e0; /* 2 */
}
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #cbd5e0; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
:root {
    --highlight: 191 74% 63%;
    --neutral: 213 22% 59%;
    --background: 236 62% 5%;
    --foreground: 0 0% 98%;
    --card: 234 64% 10%;
    --card-foreground: 0 0% 98%;
    --popover: 211 75% 16%;
    --popover-foreground: 0 0% 98%;
    --primary: 211, 77%, 68%;
    --primary-foreground: 0 0% 98%;
    --secondary: 214 66% 48%;
    --secondary-foreground: 200 50% 84%;
    --muted: 211, 76%, 8%;
    --muted-foreground: 200 46% 65%;
    --accent: 217 79% 24%;
    --accent-foreground: 0 0% 98%;
    --destructive: 0 62.8% 30.6%;
    --destructive-foreground: 0 0% 98%;
    --border: 0 0% 14.9%;
    --input: 236 52% 30%;
    --ring: 214 98% 60%;
    --chart-1: 220 70% 50%;
    --chart-2: 160 60% 45%;
    --chart-3: 30 80% 55%;
    --chart-4: 280 65% 60%;
    --chart-5: 340 75% 55%;
    --radius: 0.5rem;
    --success-bg: hsl(143, 85%, 96%);
    --success-border: hsl(145, 92%, 91%);
    --success-text: hsl(140, 100%, 27%);

    --info-bg: hsl(208, 100%, 97%);
    --info-border: hsl(221, 91%, 91%);
    --info-text: hsl(210, 92%, 45%);

    --warning-bg: hsl(49, 100%, 97%);
    --warning-border: hsl(49, 91%, 91%);
    --warning-text: hsl(31, 92%, 45%);

    --error-bg: hsl(359, 100%, 97%);
    --error-border: hsl(359, 100%, 94%);
    --error-text: hsl(360, 100%, 45%);
  }
.dark {
    --background: 0 0% 3.9%;
    --foreground: 0 0% 98%;
    --card: 234 64% 10%;
    --card-foreground: 0 0% 98%;
    --popover: 0 0% 3.9%;
    --popover-foreground: 0 0% 98%;
    --primary: 211, 77%, 68%;
    --primary-foreground: 0 0% 98%;
    --secondary: 0 0% 14.9%;
    --secondary-foreground: 0 0% 98%;
    --muted: 0 0% 14.9%;
    --muted-foreground: 0 0% 63.9%;
    --accent: 0 0% 14.9%;
    --accent-foreground: 0 0% 98%;
    --destructive: 0 62.8% 30.6%;
    --destructive-foreground: 0 0% 98%;
    --border: 0 0% 14.9%;
    --input: 236 52% 30%;
    --ring: 214 98% 60%;
    --chart-1: 220 70% 50%;
    --chart-2: 160 60% 45%;
    --chart-3: 30 80% 55%;
    --chart-4: 280 65% 60%;
    --chart-5: 340 75% 55%;
  }
html {
    font-family: 'Inter', sans-serif;
  }
body {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity)) !important;
}
*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(66, 153, 225, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
::-ms-backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(66, 153, 225, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(66, 153, 225, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
.\\!container {
  width: 100% !important;
}
@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
  .\\!container {
    max-width: 640px !important;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
  .\\!container {
    max-width: 768px !important;
  }
}
@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
  .\\!container {
    max-width: 1024px !important;
  }
}
@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
  .\\!container {
    max-width: 1280px !important;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.\\!fixed {
  position: fixed !important;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.inset-y-0 {
  top: 0;
  bottom: 0;
}
.inset-x-auto {
  left: auto;
  right: auto;
}
.top-\\[24px\\] {
  top: 24px;
}
.left-1\\/2 {
  left: 50%;
}
.bottom-\\[5px\\] {
  bottom: 5px;
}
.top-0 {
  top: 0;
}
.left-0 {
  left: 0;
}
.bottom-3 {
  bottom: 0.75rem;
}
.top-viewport {
  top: 0.5rem;
}
.left-viewport {
  left: 0.5rem;
}
.right-viewport-scrollbar {
  right: 1.3rem;
}
.bottom-viewport {
  bottom: 0.5rem;
}
.top-\\[100\\%\\] {
  top: 100%;
}
.bottom-\\[100\\%\\] {
  bottom: 100%;
}
.right-0 {
  right: 0;
}
.top-1\\/2 {
  top: 50%;
}
.left-\\[250px\\] {
  left: 250px;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-0 {
  bottom: 0;
}
.left-0\\.5 {
  left: 0.125rem;
}
.top-7 {
  top: 1.75rem;
}
.right-8 {
  right: 2rem;
}
.right-\\[8px\\] {
  right: 8px;
}
.bottom-auto {
  bottom: auto;
}
.left-auto {
  left: auto;
}
.right-auto {
  right: auto;
}
.top-auto {
  top: auto;
}
.left-\\[3px\\] {
  left: 3px;
}
.top-\\[-3px\\] {
  top: -3px;
}
.-top-1 {
  top: -0.25rem;
}
.left-\\[4px\\] {
  left: 4px;
}
.top-\\[3px\\] {
  top: 3px;
}
.top-full {
  top: 100%;
}
.top-\\[4px\\] {
  top: 4px;
}
.left-\\[0px\\] {
  left: 0px;
}
.right-\\[4px\\] {
  right: 4px;
}
.bottom-\\[4px\\] {
  bottom: 4px;
}
.right-\\[0px\\] {
  right: 0px;
}
.bottom-px {
  bottom: 1px;
}
.left-2 {
  left: 0.5rem;
}
.right-2 {
  right: 0.5rem;
}
.left-\\[50\\%\\] {
  left: 50%;
}
.top-\\[50\\%\\] {
  top: 50%;
}
.right-4 {
  right: 1rem;
}
.top-4 {
  top: 1rem;
}
.-bottom-1 {
  bottom: -0.25rem;
}
.right-\\[16px\\] {
  right: 16px;
}
.left-viewport-scrollbar {
  left: 1.3rem;
}
.isolate {
  isolation: isolate;
}
.z-\\[1000\\] {
  z-index: 1000;
}
.z-50 {
  z-index: 50;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-40 {
  z-index: 40;
}
.order-last {
  -webkit-box-ordinal-group: 10000;
      -ms-flex-order: 9999;
          order: 9999;
}
.order-first {
  -webkit-box-ordinal-group: -9998;
      -ms-flex-order: -9999;
          order: -9999;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.m-auto {
  margin: auto;
}
.m-5 {
  margin: 1.25rem;
}
.m-0 {
  margin: 0px;
}
.\\!m-0 {
  margin: 0px !important;
}
.m-1 {
  margin: 0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-1\\.5 {
  margin-left: 0.375rem;
  margin-right: 0.375rem;
}
.mx-0\\.5 {
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}
.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-8 {
  margin-left: 2rem;
  margin-right: 2rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.my-0\\.5 {
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.my-px {
  margin-top: 1px;
  margin-bottom: 1px;
}
.ml-7 {
  margin-left: 1.75rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.-mt-2 {
  margin-top: -0.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-4 {
  margin-left: 1rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mr-2\\.5 {
  margin-right: 0.625rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-0 {
  margin-top: 0px;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mt-\\[1px\\] {
  margin-top: 1px;
}
.-ml-1 {
  margin-left: -0.25rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-0 {
  margin-left: 0px;
}
.mr-auto {
  margin-right: auto;
}
.mr-0\\.5 {
  margin-right: 0.125rem;
}
.mr-0 {
  margin-right: 0px;
}
.mt-4 {
  margin-top: 1rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-\\[1ch\\] {
  margin-left: 1ch;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mt-\\[5px\\] {
  margin-top: 5px;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-\\[2px\\] {
  margin-top: 2px;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.ml-1\\.5 {
  margin-left: 0.375rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.mb-\\[12px\\] {
  margin-bottom: 12px;
}
.mb-\\[9px\\] {
  margin-bottom: 9px;
}
.mt-\\[4px\\] {
  margin-top: 4px;
}
.-mt-1 {
  margin-top: -0.25rem;
}
.mb-\\[8px\\] {
  margin-bottom: 8px;
}
.mt-\\[8px\\] {
  margin-top: 8px;
}
.mb-\\[1px\\] {
  margin-bottom: 1px;
}
.mr-\\[4px\\] {
  margin-right: 4px;
}
.mb-\\[2px\\] {
  margin-bottom: 2px;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-5 {
  margin-right: 1.25rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.box-border {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
.box-content {
  -webkit-box-sizing: content-box;
          box-sizing: content-box;
}
.block {
  display: block;
}
.\\!block {
  display: block !important;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.inline-flex {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}
.\\!inline-flex {
  display: -webkit-inline-box !important;
  display: -ms-inline-flexbox !important;
  display: inline-flex !important;
}
.table {
  display: table;
}
.flow-root {
  display: flow-root;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.\\!contents {
  display: contents !important;
}
.hidden {
  display: none;
}
.h-full {
  height: 100%;
}
.h-6 {
  height: 1.5rem;
}
.h-4 {
  height: 1rem;
}
.h-9 {
  height: 2.25rem;
}
.h-5 {
  height: 1.25rem;
}
.h-8 {
  height: 2rem;
}
.h-3 {
  height: 0.75rem;
}
.h-\\[26px\\] {
  height: 26px;
}
.h-\\[24px\\] {
  height: 24px;
}
.h-\\[28px\\] {
  height: 28px;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-\\[calc\\(100vh-300px\\)\\] {
  height: calc(100vh - 300px);
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-0 {
  height: 0px;
}
.h-screen {
  height: 100vh;
}
.h-14 {
  height: 3.5rem;
}
.h-auto {
  height: auto;
}
.h-7 {
  height: 1.75rem;
}
.h-\\[480px\\] {
  height: 480px;
}
.h-1 {
  height: 0.25rem;
}
.\\!h-\\[20px\\] {
  height: 20px !important;
}
.h-px {
  height: 1px;
}
.h-\\[500px\\] {
  height: 500px;
}
.h-\\[75px\\] {
  height: 75px;
}
.h-\\[calc\\(100\\%-32px\\)\\] {
  height: calc(100% - 32px);
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[32px\\] {
  height: 32px;
}
.h-\\[48px\\] {
  height: 48px;
}
.h-\\[25px\\] {
  height: 25px;
}
.h-10 {
  height: 2.5rem;
}
.h-\\[3px\\] {
  height: 3px;
}
.h-\\[35px\\] {
  height: 35px;
}
.h-\\[86px\\] {
  height: 86px;
}
.h-64 {
  height: 16rem;
}
.h-12 {
  height: 3rem;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[89px\\] {
  height: 89px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[6px\\] {
  height: 6px;
}
.h-\\[8px\\] {
  height: 8px;
}
.h-2 {
  height: 0.5rem;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-20 {
  height: 5rem;
}
.h-\\[34px\\] {
  height: 34px;
}
.h-\\[16px\\] {
  height: 16px;
}
.h-\\[10px\\] {
  height: 10px;
}
.h-32 {
  height: 8rem;
}
.h-11 {
  height: 2.75rem;
}
.h-\\[321px\\] {
  height: 321px;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-16 {
  height: 4rem;
}
.h-\\[512px\\] {
  height: 512px;
}
.\\!h-\\[36px\\] {
  height: 36px !important;
}
.\\!h-\\[30px\\] {
  height: 30px !important;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-\\[var\\(--radix-select-trigger-height\\)\\] {
  height: var(--radix-select-trigger-height);
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[114px\\] {
  height: 114px;
}
.h-\\[14px\\] {
  height: 14px;
}
.h-\\[15px\\] {
  height: 15px;
}
.h-\\[52px\\] {
  height: 52px;
}
.h-\\[12px\\] {
  height: 12px;
}
.h-\\[170px\\] {
  height: 170px;
}
.h-\\[calc\\(100\\%-0\\.25rem\\)\\] {
  height: calc(100% - 0.25rem);
}
.max-h-full {
  max-height: 100%;
}
.max-h-\\[500px\\] {
  max-height: 500px;
}
.max-h-64 {
  max-height: 16rem;
}
.max-h-80 {
  max-height: 20rem;
}
.max-h-0 {
  max-height: 0px;
}
.max-h-48 {
  max-height: 12rem;
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-7 {
  max-height: 1.75rem;
}
.max-h-\\[80vh\\] {
  max-height: 80vh;
}
.max-h-96 {
  max-height: 24rem;
}
.min-h-\\[1px\\] {
  min-height: 1px;
}
.min-h-0 {
  min-height: 0;
}
.min-h-\\[480px\\] {
  min-height: 480px;
}
.min-h-14 {
  min-height: 3.5rem;
}
.min-h-\\[200px\\] {
  min-height: 200px;
}
.min-h-\\[28px\\] {
  min-height: 28px;
}
.min-h-\\[18px\\] {
  min-height: 18px;
}
.w-full {
  width: 100%;
}
.w-6 {
  width: 1.5rem;
}
.w-4 {
  width: 1rem;
}
.w-5 {
  width: 1.25rem;
}
.w-3 {
  width: 0.75rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-\\[115px\\] {
  width: 115px;
}
.w-\\[58px\\] {
  width: 58px;
}
.w-\\[24px\\] {
  width: 24px;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-1\\/4 {
  width: 25%;
}
.w-4\\/24 {
  width: 16.66666667%;
}
.w-2\\/24 {
  width: 8.333333333%;
}
.w-6\\/24 {
  width: 25%;
}
.w-5\\/24 {
  width: 20.83333333%;
}
.w-screen {
  width: 100vw;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-60 {
  width: 15rem;
}
.w-28 {
  width: 7rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-10 {
  width: 2.5rem;
}
.w-0 {
  width: 0px;
}
.w-\\[262px\\] {
  width: 262px;
}
.w-7 {
  width: 1.75rem;
}
.w-16 {
  width: 4rem;
}
.w-\\[95px\\] {
  width: 95px;
}
.w-1\\/24 {
  width: 4.166666667%;
}
.w-3\\/24 {
  width: 12.5%;
}
.w-7\\/24 {
  width: 29.16666667%;
}
.w-8\\/24 {
  width: 33.33333333%;
}
.w-9\\/24 {
  width: 37.5%;
}
.w-10\\/24 {
  width: 41.66666667%;
}
.w-11\\/24 {
  width: 45.83333333%;
}
.w-12\\/24 {
  width: 50%;
}
.w-13\\/24 {
  width: 54.16666667%;
}
.w-14\\/24 {
  width: 58.33333333%;
}
.w-15\\/24 {
  width: 62.5%;
}
.w-16\\/24 {
  width: 66.66666667%;
}
.w-17\\/24 {
  width: 70.83333333%;
}
.w-18\\/24 {
  width: 75%;
}
.w-19\\/24 {
  width: 79.16666667%;
}
.w-20\\/24 {
  width: 83.33333333%;
}
.w-21\\/24 {
  width: 87.5%;
}
.w-22\\/24 {
  width: 91.66666667%;
}
.w-23\\/24 {
  width: 95.83333333%;
}
.w-48 {
  width: 12rem;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-4\\/5 {
  width: 80%;
}
.w-2 {
  width: 0.5rem;
}
.w-40 {
  width: 10rem;
}
.w-auto {
  width: auto;
}
.w-max-content {
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
}
.w-8 {
  width: 2rem;
}
.w-32 {
  width: 8rem;
}
.w-\\[28px\\] {
  width: 28px;
}
.w-\\[45px\\] {
  width: 45px;
}
.w-\\[206px\\] {
  width: 206px;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-12 {
  width: 3rem;
}
.w-\\[10px\\] {
  width: 10px;
}
.w-11\\/12 {
  width: 91.666667%;
}
.w-\\[26px\\] {
  width: 26px;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[64px\\] {
  width: 64px;
}
.w-\\[8px\\] {
  width: 8px;
}
.w-80 {
  width: 20rem;
}
.w-\\[2px\\] {
  width: 2px;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[32px\\] {
  width: 32px;
}
.w-72 {
  width: 18rem;
}
.w-56 {
  width: 14rem;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[20px\\] {
  width: 20px;
}
.w-14 {
  width: 3.5rem;
}
.w-64 {
  width: 16rem;
}
.w-\\[50px\\] {
  width: 50px;
}
.w-\\[512px\\] {
  width: 512px;
}
.w-\\[5\\.5rem\\] {
  width: 5.5rem;
}
.\\!w-\\[100\\%\\] {
  width: 100% !important;
}
.\\!w-\\[30px\\] {
  width: 30px !important;
}
.w-1 {
  width: 0.25rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[128px\\] {
  width: 128px;
}
.w-\\[15px\\] {
  width: 15px;
}
.w-\\[4px\\] {
  width: 4px;
}
.w-\\[calc\\(100\\%-12px\\)\\] {
  width: calc(100% - 12px);
}
.w-\\[135px\\] {
  width: 135px;
}
.w-px {
  width: 1px;
}
.\\!w-\\[20px\\] {
  width: 20px !important;
}
.min-w-\\[45px\\] {
  min-width: 45px;
}
.min-w-\\[1px\\] {
  min-width: 1px;
}
.min-w-\\[400px\\] {
  min-width: 400px;
}
.min-w-32 {
  min-width: 8rem;
}
.min-w-0 {
  min-width: 0;
}
.min-w-\\[32px\\] {
  min-width: 32px;
}
.min-w-16 {
  min-width: 4rem;
}
.min-w-md {
  min-width: 6rem;
}
.min-w-48 {
  min-width: 12rem;
}
.min-w-full {
  min-width: 100%;
}
.min-w-\\[8rem\\] {
  min-width: 8rem;
}
.min-w-\\[80px\\] {
  min-width: 80px;
}
.min-w-\\[60px\\] {
  min-width: 60px;
}
.\\!min-w-\\[62px\\] {
  min-width: 62px !important;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\] {
  min-width: var(--radix-select-trigger-width);
}
.min-w-\\[4px\\] {
  min-width: 4px;
}
.min-w-\\[5px\\] {
  min-width: 5px;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-xs {
  max-width: 20rem;
}
.max-w-\\[40\\%\\] {
  max-width: 40%;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-none {
  max-width: none;
}
.max-w-44 {
  max-width: 11rem;
}
.max-w-64 {
  max-width: 16rem;
}
.max-w-24 {
  max-width: 6rem;
}
.max-w-40 {
  max-width: 10rem;
}
.max-w-48 {
  max-width: 12rem;
}
.max-w-full {
  max-width: 100%;
}
.max-w-7 {
  max-width: 1.75rem;
}
.max-w-12 {
  max-width: 3rem;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-sm {
  max-width: 24rem;
}
.\\!max-w-\\[260px\\] {
  max-width: 260px !important;
}
.max-w-\\[160px\\] {
  max-width: 160px;
}
.max-w-\\[150px\\] {
  max-width: 150px;
}
.flex-1 {
  -webkit-box-flex: 1;
      -ms-flex: 1 1 0%;
          flex: 1 1 0%;
}
.flex-auto {
  -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
          flex: 1 1 auto;
}
.flex-static {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
}
.flex-initial {
  -webkit-box-flex: 0;
      -ms-flex: 0 1 auto;
          flex: 0 1 auto;
}
.flex-none {
  -webkit-box-flex: 0;
      -ms-flex: none;
          flex: none;
}
.flex-shrink-0 {
  -ms-flex-negative: 0;
      flex-shrink: 0;
}
.flex-shrink {
  -ms-flex-negative: 1;
      flex-shrink: 1;
}
.shrink-0 {
  -ms-flex-negative: 0;
      flex-shrink: 0;
}
.shrink {
  -ms-flex-negative: 1;
      flex-shrink: 1;
}
.flex-grow {
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
}
.grow {
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
}
.grow-0 {
  -webkit-box-flex: 0;
      -ms-flex-positive: 0;
          flex-grow: 0;
}
.basis-\\[200px\\] {
  -ms-flex-preferred-size: 200px;
      flex-basis: 200px;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-top-right {
  -webkit-transform-origin: top right;
          transform-origin: top right;
}
.origin-top-left {
  -webkit-transform-origin: top left;
          transform-origin: top left;
}
.origin-top {
  -webkit-transform-origin: top;
          transform-origin: top;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\] {
  --tw-translate-x: -50%;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\] {
  --tw-translate-y: -50%;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@-webkit-keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.animate-spin {
  -webkit-animation: spin 1s linear infinite;
          animation: spin 1s linear infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-auto {
  cursor: auto;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.touch-none {
  -ms-touch-action: none;
      touch-action: none;
}
.select-none {
  -webkit-user-select: none;
             -moz-user-select: none;
              -ms-user-select: none;
          user-select: none;
}
.select-text {
  -webkit-user-select: text;
             -moz-user-select: text;
              -ms-user-select: text;
          user-select: text;
}
.resize {
  resize: both;
}
.appearance-none {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-\\[repeat\\(auto-fit\\2c _minmax\\(0\\2c 135px\\)\\)\\] {
  grid-template-columns: repeat(auto-fit, minmax(0,135px));
}
.grid-cols-\\[repeat\\(auto-fit\\2c _minmax\\(0\\2c 275px\\)\\)\\] {
  grid-template-columns: repeat(auto-fit, minmax(0,275px));
}
.flex-row {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
}
.\\!flex-row {
  -webkit-box-orient: horizontal !important;
  -webkit-box-direction: normal !important;
      -ms-flex-direction: row !important;
          flex-direction: row !important;
}
.flex-row-reverse {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
      -ms-flex-direction: row-reverse;
          flex-direction: row-reverse;
}
.flex-col {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}
.flex-col-reverse {
  -webkit-box-orient: vertical;
  -webkit-box-direction: reverse;
      -ms-flex-direction: column-reverse;
          flex-direction: column-reverse;
}
.flex-wrap {
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}
.flex-nowrap {
  -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
}
.place-items-start {
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: start;
  justify-items: start;
  place-items: start;
}
.place-items-center {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  justify-items: center;
  place-items: center;
}
.items-start {
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
}
.items-end {
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
}
.items-center {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.\\!items-center {
  -webkit-box-align: center !important;
      -ms-flex-align: center !important;
          align-items: center !important;
}
.items-baseline {
  -webkit-box-align: baseline;
      -ms-flex-align: baseline;
          align-items: baseline;
}
.items-stretch {
  -webkit-box-align: stretch;
      -ms-flex-align: stretch;
          align-items: stretch;
}
.justify-start {
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
}
.justify-end {
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}
.justify-center {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
.\\!justify-center {
  -webkit-box-pack: center !important;
      -ms-flex-pack: center !important;
          justify-content: center !important;
}
.justify-between {
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}
.justify-around {
  -ms-flex-pack: distribute;
      justify-content: space-around;
}
.justify-evenly {
  -webkit-box-pack: space-evenly;
      -ms-flex-pack: space-evenly;
          justify-content: space-evenly;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-\\[4px\\] {
  gap: 4px;
}
.gap-\\[6px\\] {
  gap: 6px;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-\\[10px\\] {
  gap: 10px;
}
.gap-\\[5px\\] {
  gap: 5px;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-0 {
  gap: 0px;
}
.gap-\\[8px\\] {
  gap: 8px;
}
.\\!gap-\\[5px\\] {
  gap: 5px !important;
}
.gap-\\[2px\\] {
  gap: 2px;
}
.gap-\\[7px\\] {
  gap: 7px;
}
.gap-x-16 {
  -webkit-column-gap: 4rem;
     -moz-column-gap: 4rem;
          column-gap: 4rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-x-14 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(3.5rem * var(--tw-space-x-reverse));
  margin-left: calc(3.5rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(3.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * (1 - var(--tw-space-x-reverse)));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-px > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1px * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(1px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1px * var(--tw-space-y-reverse));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * (1 - var(--tw-space-y-reverse)));
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.self-start {
  -ms-flex-item-align: start;
      align-self: flex-start;
}
.self-end {
  -ms-flex-item-align: end;
      align-self: flex-end;
}
.self-center {
  -ms-flex-item-align: center;
      align-self: center;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-visible {
  overflow: visible;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.\\!truncate {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.overflow-ellipsis {
  text-overflow: ellipsis;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.\\!whitespace-nowrap {
  white-space: nowrap !important;
}
.whitespace-pre {
  white-space: pre;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-normal {
  word-wrap: normal;
  word-break: normal;
}
.break-words {
  word-wrap: break-word;
}
.\\!break-words {
  word-wrap: break-word !important;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-md {
  border-radius: calc(var(--radius) - 2px);
}
.rounded-lg {
  border-radius: var(--radius);
}
.rounded-\\[4px\\] {
  border-radius: 4px;
}
.rounded-\\[5px\\] {
  border-radius: 5px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-sm {
  border-radius: calc(var(--radius) - 4px);
}
.\\!rounded-lg {
  border-radius: var(--radius) !important;
}
.rounded-2xl {
  border-radius: 1rem;
}
.\\!rounded {
  border-radius: 0.25rem !important;
}
.rounded-\\[inherit\\] {
  border-radius: inherit;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-\\[2px\\] {
  border-radius: 2px;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-l {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-l-xl {
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-r {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.rounded-t {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-b-\\[4px\\] {
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
.rounded-l-\\[6px\\] {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.rounded-l-\\[4px\\] {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.rounded-b {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-b-md {
  border-bottom-right-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.rounded-t-md {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-top-right-radius: calc(var(--radius) - 2px);
}
.rounded-tl-md {
  border-top-left-radius: calc(var(--radius) - 2px);
}
.rounded-bl-md {
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.rounded-tr-md {
  border-top-right-radius: calc(var(--radius) - 2px);
}
.rounded-br-md {
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\!rounded-tr-md {
  border-top-right-radius: calc(var(--radius) - 2px) !important;
}
.\\!rounded-br-md {
  border-bottom-right-radius: calc(var(--radius) - 2px) !important;
}
.rounded-tl {
  border-top-left-radius: 0.25rem;
}
.rounded-tr {
  border-top-right-radius: 0.25rem;
}
.rounded-bl {
  border-bottom-left-radius: 0.25rem;
}
.rounded-br {
  border-bottom-right-radius: 0.25rem;
}
.\\!rounded-tr-lg {
  border-top-right-radius: var(--radius) !important;
}
.\\!rounded-br-lg {
  border-bottom-right-radius: var(--radius) !important;
}
.\\!rounded-tl-none {
  border-top-left-radius: 0px !important;
}
.\\!rounded-bl-none {
  border-bottom-left-radius: 0px !important;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[1px\\] {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-\\[2px\\] {
  border-width: 2px;
}
.border-r {
  border-right-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-\\[2px\\] {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-0 {
  border-top-width: 0px;
}
.border-l-0 {
  border-left-width: 0px;
}
.border-r-0 {
  border-right-width: 0px;
}
.border-b-0 {
  border-bottom-width: 0px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-b-4 {
  border-bottom-width: 4px;
}
.border-l-\\[2px\\] {
  border-left-width: 2px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgba(0, 0, 0, var(--tw-border-opacity));
}
.border-primary-light {
  --tw-border-opacity: 1;
  border-color: rgba(112, 169, 235, var(--tw-border-opacity));
}
.border-primary-active {
  --tw-border-opacity: 1;
  border-color: rgba(52, 140, 253, var(--tw-border-opacity));
}
.border-secondary-light {
  --tw-border-opacity: 1;
  border-color: rgba(58, 63, 153, var(--tw-border-opacity));
}
.border-transparent {
  border-color: transparent;
}
.border-common-dark {
  --tw-border-opacity: 1;
  border-color: rgba(114, 111, 126, var(--tw-border-opacity));
}
.border-highlight {
  border-color: hsl(var(--highlight));
}
.border-secondary-light\\/60 {
  border-color: rgba(58, 63, 153, .60);
}
.border-primary-dark {
  --tw-border-opacity: 1;
  border-color: rgba(9, 12, 41, var(--tw-border-opacity));
}
.border-primary-main {
  --tw-border-opacity: 1;
  border-color: rgba(9, 68, 179, var(--tw-border-opacity));
}
.border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgba(160, 174, 192, var(--tw-border-opacity));
}
.border-secondary-main {
  --tw-border-opacity: 1;
  border-color: rgba(43, 22, 107, var(--tw-border-opacity));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}
.border-inputfield-main {
  --tw-border-opacity: 1;
  border-color: rgba(58, 63, 153, var(--tw-border-opacity));
}
.border-secondary-dark {
  --tw-border-opacity: 1;
  border-color: rgba(10, 34, 64, var(--tw-border-opacity));
}
.border-customblue-10 {
  --tw-border-opacity: 1;
  border-color: rgba(10, 22, 63, var(--tw-border-opacity));
}
.border-common-bright {
  --tw-border-opacity: 1;
  border-color: rgba(225, 225, 225, var(--tw-border-opacity));
}
.border-primary\\/25 {
  border-color: hsl(var(--primary) / .25);
}
.border-input {
  border-color: hsl(var(--input));
}
.border-primary {
  border-color: hsl(var(--primary));
}
.border-background {
  border-color: hsl(var(--background));
}
.border-input\\/50 {
  border-color: hsl(var(--input) / .50);
}
.border-white\\/10 {
  border-color: rgba(255, 255, 255, .10);
}
.border-primary\\/70 {
  border-color: hsl(var(--primary) / .70);
}
.border-primary\\/35 {
  border-color: hsl(var(--primary) / .35);
}
.border-primary\\/60 {
  border-color: hsl(var(--primary) / .60);
}
.border-b-secondary-light {
  --tw-border-opacity: 1;
  border-bottom-color: rgba(58, 63, 153, var(--tw-border-opacity));
}
.border-b-gray-900 {
  --tw-border-opacity: 1;
  border-bottom-color: rgba(26, 32, 44, var(--tw-border-opacity));
}
.border-l-transparent {
  border-left-color: transparent;
}
.border-t-transparent {
  border-top-color: transparent;
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
}
.bg-primary-light {
  --tw-bg-opacity: 1;
  background-color: rgba(112, 169, 235, var(--tw-bg-opacity));
}
.bg-popover {
  background-color: hsl(var(--popover));
}
.bg-muted {
  background-color: hsl(var(--muted));
}
.bg-highlight {
  background-color: hsl(var(--highlight));
}
.bg-background {
  background-color: hsl(var(--background));
}
.bg-input {
  background-color: hsl(var(--input));
}
.bg-customgray-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(38, 41, 67, var(--tw-bg-opacity));
}
.bg-secondary-dark {
  --tw-bg-opacity: 1;
  background-color: rgba(10, 34, 64, var(--tw-bg-opacity));
}
.bg-black\\/\\[\\.4\\] {
  background-color: rgba(0, 0, 0, .4);
}
.bg-transparent {
  background-color: transparent;
}
.bg-primary-dark {
  --tw-bg-opacity: 1;
  background-color: rgba(9, 12, 41, var(--tw-bg-opacity));
}
.bg-primary-main {
  --tw-bg-opacity: 1;
  background-color: rgba(9, 68, 179, var(--tw-bg-opacity));
}
.bg-customblue-30 {
  --tw-bg-opacity: 1;
  background-color: rgba(9, 40, 110, var(--tw-bg-opacity));
}
.bg-inputfield-placeholder {
  --tw-bg-opacity: 1;
  background-color: rgba(57, 56, 63, var(--tw-bg-opacity));
}
.bg-customblue-40 {
  --tw-bg-opacity: 1;
  background-color: rgba(14, 48, 127, var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
.bg-primary-active {
  --tw-bg-opacity: 1;
  background-color: rgba(52, 140, 253, var(--tw-bg-opacity));
}
.bg-\\[\\#04225b\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(4, 34, 91, var(--tw-bg-opacity));
}
.bg-secondary-light {
  --tw-bg-opacity: 1;
  background-color: rgba(58, 63, 153, var(--tw-bg-opacity));
}
.bg-secondary-main {
  --tw-bg-opacity: 1;
  background-color: rgba(43, 22, 107, var(--tw-bg-opacity));
}
.\\!bg-primary-dark {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(9, 12, 41, var(--tw-bg-opacity)) !important;
}
.bg-indigo-dark {
  --tw-bg-opacity: 1;
  background-color: rgba(11, 26, 66, var(--tw-bg-opacity));
}
.bg-overlay {
  background-color: rgba(0, 0, 0, 0.8);
}
.bg-customblue-400 {
  --tw-bg-opacity: 1;
  background-color: rgba(144, 160, 193, var(--tw-bg-opacity));
}
.bg-\\[\\#212456\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(33, 36, 86, var(--tw-bg-opacity));
}
.bg-\\[\\#bed1db\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(190, 209, 219, var(--tw-bg-opacity));
}
.bg-\\[\\#ebe5c4\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(235, 229, 196, var(--tw-bg-opacity));
}
.bg-\\[\\#c6d9bf\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(198, 217, 191, var(--tw-bg-opacity));
}
.bg-\\[\\#dabdbe\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(218, 189, 190, var(--tw-bg-opacity));
}
.bg-common-bright {
  --tw-bg-opacity: 1;
  background-color: rgba(225, 225, 225, var(--tw-bg-opacity));
}
.bg-popover\\/90 {
  background-color: hsl(var(--popover) / .90);
}
.bg-primary\\/60 {
  background-color: hsl(var(--primary) / .60);
}
.bg-destructive {
  background-color: hsl(var(--destructive));
}
.bg-primary\\/40 {
  background-color: hsl(var(--primary) / .40);
}
.bg-accent {
  background-color: hsl(var(--accent));
}
.bg-card {
  background-color: hsl(var(--card));
}
.bg-border {
  background-color: hsl(var(--border));
}
.bg-primary\\/20 {
  background-color: hsl(var(--primary) / .20);
}
.bg-black\\/60 {
  background-color: rgba(0, 0, 0, .60);
}
.bg-primary\\/30 {
  background-color: hsl(var(--primary) / .30);
}
.bg-primary {
  background-color: hsl(var(--primary));
}
.bg-black\\/80 {
  background-color: rgba(0, 0, 0, .80);
}
.bg-foreground {
  background-color: hsl(var(--foreground));
}
.\\!bg-popover {
  background-color: hsl(var(--popover)) !important;
}
.\\!bg-\\[\\#348cfd\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(52, 140, 253, var(--tw-bg-opacity)) !important;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.bg-neutral\\/50 {
  background-color: hsl(var(--neutral) / .50);
}
.bg-bkg-low {
  --tw-bg-opacity: 1;
  background-color: rgba(7, 30, 54, var(--tw-bg-opacity));
}
.bg-bkg-med {
  --tw-bg-opacity: 1;
  background-color: rgba(8, 28, 53, var(--tw-bg-opacity));
}
.bg-primary\\/65 {
  background-color: hsl(var(--primary) / .65);
}
.bg-primary\\/25 {
  background-color: hsl(var(--primary) / .25);
}
.bg-primary\\/10 {
  background-color: hsl(var(--primary) / .10);
}
.bg-\\[\\#222d44\\] {
  --tw-bg-opacity: 1;
  background-color: rgba(34, 45, 68, var(--tw-bg-opacity));
}
.bg-opacity-50 {
  --tw-bg-opacity: .50;
}
.bg-gradient-to-b {
  background-image: -webkit-gradient(linear, left top, left bottom, from(var(--tw-gradient-stops)));
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: -webkit-gradient(linear, left bottom, left top, from(var(--tw-gradient-stops)));
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-background {
  --tw-gradient-from: hsl(var(--background));
  --tw-gradient-to: hsl(var(--background) / 0);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-background\\/80 {
  --tw-gradient-to: hsl(var(--background) / 0);
  --tw-gradient-stops: var(--tw-gradient-from), hsl(var(--background) / .80), var(--tw-gradient-to);
}
.to-transparent {
  --tw-gradient-to: transparent;
}
.fill-current {
  fill: currentColor;
}
.stroke-secondary-light {
  stroke: #3a3f99;
}
.stroke-1 {
  stroke-width: 1;
}
.object-contain {
  -o-object-fit: contain;
     object-fit: contain;
}
.p-4 {
  padding: 1rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-0 {
  padding: 0px;
}
.p-3\\.5 {
  padding: 0.875rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-px {
  padding: 1px;
}
.p-5 {
  padding: 1.25rem;
}
.\\!p-2 {
  padding: 0.5rem !important;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-\\[12px\\] {
  padding: 12px;
}
.p-\\[2px\\] {
  padding: 2px;
}
.p-\\[1px\\] {
  padding: 1px;
}
.p-\\[4px\\] {
  padding: 4px;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-\\[10px\\] {
  padding-left: 10px;
  padding-right: 10px;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-\\[20px\\] {
  padding-left: 20px;
  padding-right: 20px;
}
.px-9 {
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}
.\\!py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-\\[13px\\] {
  padding-top: 13px;
  padding-bottom: 13px;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}
.py-\\[3px\\] {
  padding-top: 3px;
  padding-bottom: 3px;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-\\[6px\\] {
  padding-top: 6px;
  padding-bottom: 6px;
}
.px-\\[8px\\] {
  padding-left: 8px;
  padding-right: 8px;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.py-\\[6\\.5px\\] {
  padding-top: 6.5px;
  padding-bottom: 6.5px;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.\\!px-\\[10px\\] {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pr-0\\.5 {
  padding-right: 0.125rem;
}
.pr-0 {
  padding-right: 0px;
}
.pl-1\\.5 {
  padding-left: 0.375rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-0\\.5 {
  padding-left: 0.125rem;
}
.pl-0 {
  padding-left: 0px;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-4 {
  padding-top: 1rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pr-9 {
  padding-right: 2.25rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pb-\\[20px\\] {
  padding-bottom: 20px;
}
.pt-\\[13px\\] {
  padding-top: 13px;
}
.pt-\\[20px\\] {
  padding-top: 20px;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pl-\\[2px\\] {
  padding-left: 2px;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-\\[22px\\] {
  padding-left: 22px;
}
.pr-\\[22px\\] {
  padding-right: 22px;
}
.pt-\\[10px\\] {
  padding-top: 10px;
}
.pb-\\[10px\\] {
  padding-bottom: 10px;
}
.\\!pl-2 {
  padding-left: 0.5rem !important;
}
.pl-2\\.5 {
  padding-left: 0.625rem;
}
.pl-\\[34px\\] {
  padding-left: 34px;
}
.pb-\\[5px\\] {
  padding-bottom: 5px;
}
.pb-\\[9px\\] {
  padding-bottom: 9px;
}
.pr-1\\.5 {
  padding-right: 0.375rem;
}
.pt-\\[3px\\] {
  padding-top: 3px;
}
.pl-\\[43px\\] {
  padding-left: 43px;
}
.pl-\\[45px\\] {
  padding-left: 45px;
}
.pt-\\[5px\\] {
  padding-top: 5px;
}
.pr-\\[8px\\] {
  padding-right: 8px;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-2\\.5 {
  padding-right: 0.625rem;
}
.pt-1\\.5 {
  padding-top: 0.375rem;
}
.pb-\\[2px\\] {
  padding-bottom: 2px;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pl-12 {
  padding-left: 3rem;
}
.pl-\\[4px\\] {
  padding-left: 4px;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pb-\\[0\\.5\\] {
  padding-bottom: 0.5;
}
.pb-2\\.5 {
  padding-bottom: 0.625rem;
}
.pl-\\[6\\.5px\\] {
  padding-left: 6.5px;
}
.pr-\\[6\\.5px\\] {
  padding-right: 6.5px;
}
.pr-px {
  padding-right: 1px;
}
.pr-7 {
  padding-right: 1.75rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pl-\\[8px\\] {
  padding-left: 8px;
}
.pr-8 {
  padding-right: 2rem;
}
.pl-\\[10px\\] {
  padding-left: 10px;
}
.pr-\\[6px\\] {
  padding-right: 6px;
}
.pl-\\[5px\\] {
  padding-left: 5px;
}
.pt-px {
  padding-top: 1px;
}
.pb-0\\.5 {
  padding-bottom: 0.125rem;
}
.pt-\\[4px\\] {
  padding-top: 4px;
}
.pb-\\[4px\\] {
  padding-bottom: 4px;
}
.pr-\\[2\\.5px\\] {
  padding-right: 2.5px;
}
.pt-12 {
  padding-top: 3rem;
}
.pt-48 {
  padding-top: 12rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.\\!text-center {
  text-align: center !important;
}
.text-right {
  text-align: right;
}
.text-justify {
  text-align: justify;
}
[dir="ltr"] .text-end {
  text-align: right;
}
[dir="rtl"] .text-end {
  text-align: left;
}
.font-sans {
  font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.font-mono {
  font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.\\!font-sans {
  font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}
.text-base {
  font-size: 0.8125rem;
}
.text-sm {
  font-size: 0.75rem;
}
.text-xs {
  font-size: 0.6875rem;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-lg {
  font-size: 0.875rem;
}
.text-xl {
  font-size: 1rem;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[19px\\] {
  font-size: 19px;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[0px\\] {
  font-size: 0px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-6xl {
  font-size: 4rem;
}
.text-5xl {
  font-size: 3rem;
}
.text-4xl {
  font-size: 2.25rem;
}
.text-3xl {
  font-size: 1.875rem;
}
.text-2xl {
  font-size: 1.5rem;
}
.text-\\[0\\.8rem\\] {
  font-size: 0.8rem;
}
.\\!text-xl {
  font-size: 1rem !important;
}
.\\!text-\\[14px\\] {
  font-size: 14px !important;
}
.font-bold {
  font-weight: 700;
}
.font-light {
  font-weight: 300;
}
.font-semibold {
  font-weight: 600;
}
.font-medium {
  font-weight: 500;
}
.font-\\[300\\] {
  font-weight: 300;
}
.font-normal {
  font-weight: 400;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.italic {
  font-style: italic;
}
.ordinal {
  --tw-ordinal: ordinal;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-normal {
  line-height: 1.5;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-5 {
  line-height: 1.25rem;
}
.\\!leading-\\[1\\.2\\] {
  line-height: 1.2 !important;
}
.leading-\\[1\\.2\\] {
  line-height: 1.2;
}
.leading-\\[22px\\] {
  line-height: 22px;
}
.leading-tight {
  line-height: 1.25;
}
.leading-none {
  line-height: 1;
}
.leading-10 {
  line-height: 2.5rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-3 {
  line-height: .75rem;
}
.leading-\\[18px\\] {
  line-height: 18px;
}
.\\!leading-\\[1\\.5\\] {
  line-height: 1.5 !important;
}
.leading-4 {
  line-height: 1rem;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.\\!text-black {
  --tw-text-opacity: 1 !important;
  color: rgba(0, 0, 0, var(--tw-text-opacity)) !important;
}
.\\!text-common-bright {
  --tw-text-opacity: 1 !important;
  color: rgba(225, 225, 225, var(--tw-text-opacity)) !important;
}
.text-secondary-foreground {
  color: hsl(var(--secondary-foreground));
}
.text-foreground {
  color: hsl(var(--foreground));
}
.text-primary {
  color: hsl(var(--primary));
}
.text-muted-foreground {
  color: hsl(var(--muted-foreground));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgba(229, 62, 62, var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.text-aqua-pale {
  --tw-text-opacity: 1;
  color: rgba(123, 178, 206, var(--tw-text-opacity));
}
.text-primary-light {
  --tw-text-opacity: 1;
  color: rgba(112, 169, 235, var(--tw-text-opacity));
}
.text-foreground\\/70 {
  color: hsl(var(--foreground) / .70);
}
.text-highlight\\/65 {
  color: hsl(var(--highlight) / .65);
}
.text-foreground\\/60 {
  color: hsl(var(--foreground) / .60);
}
.text-highlight {
  color: hsl(var(--highlight));
}
.text-actions-primary {
  --tw-text-opacity: 1;
  color: rgba(52, 140, 253, var(--tw-text-opacity));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgba(66, 153, 225, var(--tw-text-opacity));
}
.text-primary-active {
  --tw-text-opacity: 1;
  color: rgba(52, 140, 253, var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
.text-common-light {
  --tw-text-opacity: 1;
  color: rgba(161, 159, 173, var(--tw-text-opacity));
}
.text-secondary-active {
  --tw-text-opacity: 1;
  color: rgba(31, 31, 39, var(--tw-text-opacity));
}
.text-common-dark {
  --tw-text-opacity: 1;
  color: rgba(114, 111, 126, var(--tw-text-opacity));
}
.text-blue-300 {
  --tw-text-opacity: 1;
  color: rgba(144, 205, 244, var(--tw-text-opacity));
}
.text-common-bright {
  --tw-text-opacity: 1;
  color: rgba(225, 225, 225, var(--tw-text-opacity));
}
.text-primary-main {
  --tw-text-opacity: 1;
  color: rgba(9, 68, 179, var(--tw-text-opacity));
}
.text-secondary-light {
  --tw-text-opacity: 1;
  color: rgba(58, 63, 153, var(--tw-text-opacity));
}
.text-\\[\\#726f7e\\] {
  --tw-text-opacity: 1;
  color: rgba(114, 111, 126, var(--tw-text-opacity));
}
.\\!text-primary-light {
  --tw-text-opacity: 1 !important;
  color: rgba(112, 169, 235, var(--tw-text-opacity)) !important;
}
.text-primary-dark {
  --tw-text-opacity: 1;
  color: rgba(9, 12, 41, var(--tw-text-opacity));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgba(197, 48, 48, var(--tw-text-opacity));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgba(236, 201, 75, var(--tw-text-opacity));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgba(72, 187, 120, var(--tw-text-opacity));
}
.text-\\[\\#b3b3b3\\] {
  --tw-text-opacity: 1;
  color: rgba(179, 179, 179, var(--tw-text-opacity));
}
.text-\\[\\#d8d8d8\\] {
  --tw-text-opacity: 1;
  color: rgba(216, 216, 216, var(--tw-text-opacity));
}
.text-\\[\\#3d5871\\] {
  --tw-text-opacity: 1;
  color: rgba(61, 88, 113, var(--tw-text-opacity));
}
.text-\\[\\#0944b3\\] {
  --tw-text-opacity: 1;
  color: rgba(9, 68, 179, var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgba(245, 101, 101, var(--tw-text-opacity));
}
.text-inherit {
  color: inherit;
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgba(45, 55, 72, var(--tw-text-opacity));
}
.text-blue-400 {
  --tw-text-opacity: 1;
  color: rgba(99, 179, 237, var(--tw-text-opacity));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgba(49, 130, 206, var(--tw-text-opacity));
}
.\\!text-primary {
  color: hsl(var(--primary)) !important;
}
.text-primary-foreground {
  color: hsl(var(--primary-foreground));
}
.text-destructive-foreground {
  color: hsl(var(--destructive-foreground));
}
.text-accent-foreground {
  color: hsl(var(--accent-foreground));
}
.text-card-foreground {
  color: hsl(var(--card-foreground));
}
.text-background {
  color: hsl(var(--background));
}
.text-popover-foreground {
  color: hsl(var(--popover-foreground));
}
.text-foreground\\/80 {
  color: hsl(var(--foreground) / .80);
}
.\\!text-highlight {
  color: hsl(var(--highlight)) !important;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgba(255, 255, 255, var(--tw-text-opacity)) !important;
}
.\\!text-\\[\\#348cfd\\] {
  --tw-text-opacity: 1 !important;
  color: rgba(52, 140, 253, var(--tw-text-opacity)) !important;
}
.text-foreground\\/50 {
  color: hsl(var(--foreground) / .50);
}
.text-primary-foreground\\/80 {
  color: hsl(var(--primary-foreground) / .80);
}
.underline {
  text-decoration-line: underline;
}
.overline {
  text-decoration-line: overline;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.placeholder-inputfield-placeholder::-webkit-input-placeholder {
  --tw-placeholder-opacity: 1;
  color: rgba(57, 56, 63, var(--tw-placeholder-opacity));
}
.placeholder-inputfield-placeholder::-moz-placeholder {
  --tw-placeholder-opacity: 1;
  color: rgba(57, 56, 63, var(--tw-placeholder-opacity));
}
.placeholder-inputfield-placeholder:-ms-input-placeholder {
  --tw-placeholder-opacity: 1;
  color: rgba(57, 56, 63, var(--tw-placeholder-opacity));
}
.placeholder-inputfield-placeholder::-ms-input-placeholder {
  --tw-placeholder-opacity: 1;
  color: rgba(57, 56, 63, var(--tw-placeholder-opacity));
}
.placeholder-inputfield-placeholder::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgba(57, 56, 63, var(--tw-placeholder-opacity));
}
.caret-accent-foreground {
  caret-color: hsl(var(--accent-foreground));
}
.opacity-100 {
  opacity: 1;
}
.opacity-50 {
  opacity: .50;
}
.opacity-0 {
  opacity: 0;
}
.opacity-\\[0\\.67\\] {
  opacity: 0.67;
}
.\\!opacity-40 {
  opacity: .40 !important;
}
.opacity-90 {
  opacity: .90;
}
.opacity-60 {
  opacity: .60;
}
.opacity-70 {
  opacity: .70;
}
.opacity-40 {
  opacity: .40;
}
.opacity-80 {
  opacity: .80;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px 0 var(--tw-shadow-color);
  -webkit-box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
          box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
          box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  -webkit-box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
          box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
          box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -2px var(--tw-shadow-color);
  -webkit-box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
          box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
          box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-\\[0_0_0_200px_transparent\\] {
  --tw-shadow: 0 0 0 200px transparent;
  --tw-shadow-colored: 0 0 0 200px var(--tw-shadow-color);
  -webkit-box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
          box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
          box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -1px var(--tw-shadow-color);
  -webkit-box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
          box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
          box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  -webkit-box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
          box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
          box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.\\!outline-none {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.outline {
  outline-style: solid;
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.ring-offset-background {
  --tw-ring-offset-color: hsl(var(--background));
}
.blur {
  --tw-blur: blur(8px);
  -webkit-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
          filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-md {
  --tw-drop-shadow: drop-shadow(0 4px 3px rgba(0, 0, 0, 0.07)) drop-shadow(0 2px 2px rgba(0, 0, 0, 0.06));
  -webkit-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
          filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-lg {
  --tw-drop-shadow: drop-shadow(0 10px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0 4px 3px rgba(0, 0, 0, 0.1));
  -webkit-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
          filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  -webkit-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
          filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert {
  --tw-invert: invert(100%);
  -webkit-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
          filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!invert {
  --tw-invert: invert(100%) !important;
  -webkit-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
          filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter {
  -webkit-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
          filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!filter {
  -webkit-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
          filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.backdrop-filter {
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition-opacity {
  -webkit-transition-property: opacity;
  transition-property: opacity;
}
.transition-transform {
  -webkit-transition-property: -webkit-transform;
  transition-property: -webkit-transform;
  transition-property: transform;
  transition-property: transform, -webkit-transform;
}
.transition {
  -webkit-transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform;
  transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, -webkit-box-shadow, -webkit-transform;
}
.transition-all {
  -webkit-transition-property: all;
  transition-property: all;
}
.transition-\\[max-height\\] {
  -webkit-transition-property: max-height;
  transition-property: max-height;
}
.transition-height {
  -webkit-transition-property: height;
  transition-property: height;
}
.transition-colors {
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
}
.\\!transition {
  -webkit-transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform !important;
  transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform !important;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform !important;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, -webkit-box-shadow, -webkit-transform !important;
}
.duration-200 {
  -webkit-transition-duration: 200ms;
          transition-duration: 200ms;
}
.duration-300 {
  -webkit-transition-duration: 300ms;
          transition-duration: 300ms;
}
.duration-500 {
  -webkit-transition-duration: 500ms;
          transition-duration: 500ms;
}
.duration-1000 {
  -webkit-transition-duration: 1000ms;
          transition-duration: 1000ms;
}
.duration-150 {
  -webkit-transition-duration: 150ms;
          transition-duration: 150ms;
}
.\\!duration-300 {
  -webkit-transition-duration: 300ms !important;
          transition-duration: 300ms !important;
}
.ease-in-out {
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
          transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-in {
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
          transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-out {
  -webkit-transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
          transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\!ease-in-out {
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
          transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}
@-webkit-keyframes enter {
  from {
    opacity: 1;
    opacity: var(--tw-enter-opacity, 1);
    -webkit-transform: translate3d(0, 0, 0) scale3d(1, 1, 1) rotate(0);
            transform: translate3d(0, 0, 0) scale3d(1, 1, 1) rotate(0);
    -webkit-transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
            transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes enter {
  from {
    opacity: 1;
    opacity: var(--tw-enter-opacity, 1);
    -webkit-transform: translate3d(0, 0, 0) scale3d(1, 1, 1) rotate(0);
            transform: translate3d(0, 0, 0) scale3d(1, 1, 1) rotate(0);
    -webkit-transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
            transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@-webkit-keyframes exit {
  to {
    opacity: 1;
    opacity: var(--tw-exit-opacity, 1);
    -webkit-transform: translate3d(0, 0, 0) scale3d(1, 1, 1) rotate(0);
            transform: translate3d(0, 0, 0) scale3d(1, 1, 1) rotate(0);
    -webkit-transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
            transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
@keyframes exit {
  to {
    opacity: 1;
    opacity: var(--tw-exit-opacity, 1);
    -webkit-transform: translate3d(0, 0, 0) scale3d(1, 1, 1) rotate(0);
            transform: translate3d(0, 0, 0) scale3d(1, 1, 1) rotate(0);
    -webkit-transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
            transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in {
  -webkit-animation-name: enter;
          animation-name: enter;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in-0 {
  --tw-enter-opacity: 0;
}
.zoom-in {
  --tw-enter-scale: 0;
}
.zoom-out {
  --tw-exit-scale: 0;
}
.zoom-in-95 {
  --tw-enter-scale: .95;
}
.duration-200 {
  -webkit-animation-duration: 200ms;
          animation-duration: 200ms;
}
.duration-300 {
  -webkit-animation-duration: 300ms;
          animation-duration: 300ms;
}
.duration-500 {
  -webkit-animation-duration: 500ms;
          animation-duration: 500ms;
}
.duration-1000 {
  -webkit-animation-duration: 1000ms;
          animation-duration: 1000ms;
}
.duration-150 {
  -webkit-animation-duration: 150ms;
          animation-duration: 150ms;
}
.\\!duration-300 {
  -webkit-animation-duration: 300ms !important;
          animation-duration: 300ms !important;
}
.ease-in-out {
  -webkit-animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
          animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-in {
  -webkit-animation-timing-function: cubic-bezier(0.4, 0, 1, 1);
          animation-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-out {
  -webkit-animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
          animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\!ease-in-out {
  -webkit-animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
          animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}
.running {
  -webkit-animation-play-state: running;
          animation-play-state: running;
}
.paused {
  -webkit-animation-play-state: paused;
          animation-play-state: paused;
}
.\\[overflow\\:hidden\\] {
  overflow: hidden;
}
.\\[display\\:-webkit-box\\] {
  display: -webkit-box;
}
.\\[-webkit-line-clamp\\:2\\] {
  -webkit-line-clamp: 2;
}
.\\[-webkit-box-orient\\:vertical\\] {
  -webkit-box-orient: vertical;
}
/* OHIF Theme */
/* ORIGINAL THEME for comparison and testing

@layer base {
  :root {
    --background: 0 0% 100%;
    --foreground: 240 10% 3.9%;
    --card: 0 0% 100%;
    --card-foreground: 240 10% 3.9%;
    --popover: 0 0% 100%;
    --popover-foreground: 240 10% 3.9%;
    --primary: 240 5.9% 10%;
    --primary-foreground: 0 0% 98%;
    --secondary: 240 4.8% 95.9%;
    --secondary-foreground: 240 5.9% 10%;
    --muted: 240 4.8% 95.9%;
    --muted-foreground: 240 3.8% 46.1%;
    --accent: 240 4.8% 95.9%;
    --accent-foreground: 240 5.9% 10%;
    --destructive: 0 72.22% 50.59%;
    --destructive-foreground: 0 0% 98%;
    --border: 240 5.9% 90%;
    --input: 240 5.9% 90%;
    --ring: 240 5% 64.9%;
    --radius: 0.5rem;

    --chart-1: 12 76% 61%;
    --chart-2: 173 58% 39%;
    --chart-3: 197 37% 24%;
    --chart-4: 43 74% 66%;
    --chart-5: 27 87% 67%;
  }


  .dark {
    --background: 240 10% 3.9%;
    --foreground: 0 0% 98%;
    --card: 240 10% 3.9%;
    --card-foreground: 0 0% 98%;
    --popover: 240 10% 3.9%;
    --popover-foreground: 0 0% 98%;
    --primary: 0 0% 98%;
    --primary-foreground: 240 5.9% 10%;
    --secondary: 240 3.7% 15.9%;
    --secondary-foreground: 0 0% 98%;
    --muted: 240 3.7% 15.9%;
    --muted-foreground: 240 5% 64.9%;
    --accent: 240 3.7% 15.9%;
    --accent-foreground: 0 0% 98%;
    --destructive: 0 62.8% 30.6%;
    --destructive-foreground: 0 85.7% 97.3%;
    --border: 240 3.7% 15.9%;
    --input: 240 3.7% 15.9%;
    --ring: 240 4.9% 83.9%;

    --chart-1: 220 70% 50%;
    --chart-2: 160 60% 45%;
    --chart-3: 30 80% 55%;
    --chart-4: 280 65% 60%;
    --chart-5: 340 75% 55%;
  }
}

*/
/* Theme Copy Example

@layer base {
  :root {
    --background: 0 0% 100%;
    --foreground: 224 71.4% 4.1%;
    --card: 0 0% 100%;
    --card-foreground: 224 71.4% 4.1%;
    --popover: 0 0% 100%;
    --popover-foreground: 224 71.4% 4.1%;
    --primary: 262.1 83.3% 57.8%;
    --primary-foreground: 210 20% 98%;
    --secondary: 220 14.3% 95.9%;
    --secondary-foreground: 220.9 39.3% 11%;
    --muted: 220 14.3% 95.9%;
    --muted-foreground: 220 8.9% 46.1%;
    --accent: 220 14.3% 95.9%;
    --accent-foreground: 220.9 39.3% 11%;
    --destructive: 360 84.2% 60.2%;
    --destructive-foreground: 210 20% 98%;
    --border: 220 13% 91%;
    --input: 220 13% 91%;
    --ring: 262.1 83.3% 57.8%;
    --radius: 0.5rem;
    --chart-1: ;
    --chart-2: ;
    --chart-3: ;
    --chart-4: ;
    --chart-5: ;
  }

  .dark {
    --background: 224 71.4% 4.1%;
    --foreground: 210 20% 98%;
    --card: 224 71.4% 4.1%;
    --card-foreground: 210 20% 98%;
    --popover: 224 71.4% 4.1%;
    --popover-foreground: 210 20% 98%;
    --primary: 263.4 70% 50.4%;
    --primary-foreground: 210 20% 98%;
    --secondary: 215 27.9% 16.9%;
    --secondary-foreground: 210 20% 98%;
    --muted: 215 27.9% 16.9%;
    --muted-foreground: 217.9 10.6% 64.9%;
    --accent: 215 27.9% 16.9%;
    --accent-foreground: 210 20% 98%;
    --destructive: 360 84.2% 60.2%;
    --destructive-foreground: 210 20% 98%;
    --border: 215 27.9% 16.9%;
    --input: 215 27.9% 16.9%;
    --ring: 263.4 70% 50.4%;
    --chart-1: ;
    --chart-2: ;
    --chart-3: ;
    --chart-4: ;
    --chart-5: ;
  }
}

*/
/* Updated Playground page styles */
h2.section-header {
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 1.5rem;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
h3.section-header {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 1rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.row {
  margin-bottom: 1.5rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  border-radius: calc(var(--radius) - 2px);
  border-width: 1px;
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.example {
  -webkit-box-flex: 0;
      -ms-flex: 0 1 auto;
          flex: 0 1 auto;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.example2 {
  -webkit-box-flex: 0;
      -ms-flex: 0 1 auto;
          flex: 0 1 auto;
  padding-left: 1rem;
  padding-right: 1rem;
}
/* Additional CSS edits to components */
/* Tooltip */
.TooltipContent[data-side='bottom'] {
  -webkit-animation-name: slideDown;
          animation-name: slideDown;
}
/* Custom CSS to hide default number input arrows */
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
          appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield; /* For Firefox */
}
.file\\:border-0::-webkit-file-upload-button {
  border-width: 0px;
}
.file\\:border-0::file-selector-button {
  border-width: 0px;
}
.file\\:bg-transparent::-webkit-file-upload-button {
  background-color: transparent;
}
.file\\:bg-transparent::file-selector-button {
  background-color: transparent;
}
.file\\:text-base::-webkit-file-upload-button {
  font-size: 0.8125rem;
}
.file\\:text-base::file-selector-button {
  font-size: 0.8125rem;
}
.file\\:font-medium::-webkit-file-upload-button {
  font-weight: 500;
}
.file\\:font-medium::file-selector-button {
  font-weight: 500;
}
.placeholder\\:text-inputfield-placeholder::-webkit-input-placeholder {
  --tw-text-opacity: 1;
  color: rgba(57, 56, 63, var(--tw-text-opacity));
}
.placeholder\\:text-inputfield-placeholder::-moz-placeholder {
  --tw-text-opacity: 1;
  color: rgba(57, 56, 63, var(--tw-text-opacity));
}
.placeholder\\:text-inputfield-placeholder:-ms-input-placeholder {
  --tw-text-opacity: 1;
  color: rgba(57, 56, 63, var(--tw-text-opacity));
}
.placeholder\\:text-inputfield-placeholder::-ms-input-placeholder {
  --tw-text-opacity: 1;
  color: rgba(57, 56, 63, var(--tw-text-opacity));
}
.placeholder\\:text-inputfield-placeholder::placeholder {
  --tw-text-opacity: 1;
  color: rgba(57, 56, 63, var(--tw-text-opacity));
}
.placeholder\\:text-muted-foreground::-webkit-input-placeholder {
  color: hsl(var(--muted-foreground));
}
.placeholder\\:text-muted-foreground::-moz-placeholder {
  color: hsl(var(--muted-foreground));
}
.placeholder\\:text-muted-foreground:-ms-input-placeholder {
  color: hsl(var(--muted-foreground));
}
.placeholder\\:text-muted-foreground::-ms-input-placeholder {
  color: hsl(var(--muted-foreground));
}
.placeholder\\:text-muted-foreground::placeholder {
  color: hsl(var(--muted-foreground));
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-y-0::after {
  content: var(--tw-content);
  top: 0;
  bottom: 0;
}
.after\\:left-1\\/2::after {
  content: var(--tw-content);
  left: 50%;
}
.after\\:w-1::after {
  content: var(--tw-content);
  width: 0.25rem;
}
.after\\:-translate-x-1\\/2::after {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.first\\:rounded-t:first-child {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.first\\:rounded-t-md:first-child {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-top-right-radius: calc(var(--radius) - 2px);
}
.first\\:rounded-t-lg:first-child {
  border-top-left-radius: var(--radius);
  border-top-right-radius: var(--radius);
}
.first\\:rounded-t-full:first-child {
  border-top-left-radius: 9999px;
  border-top-right-radius: 9999px;
}
.first\\:rounded-l:first-child {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.first\\:rounded-l-md:first-child {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.first\\:rounded-l-lg:first-child {
  border-top-left-radius: var(--radius);
  border-bottom-left-radius: var(--radius);
}
.first\\:rounded-l-full:first-child {
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.first\\:rounded-l-sm:first-child {
  border-top-left-radius: calc(var(--radius) - 4px);
  border-bottom-left-radius: calc(var(--radius) - 4px);
}
.first\\:border-0:first-child {
  border-width: 0px;
}
.first\\:pl-12:first-child {
  padding-left: 3rem;
}
.last\\:mr-0:last-child {
  margin-right: 0px;
}
.last\\:rounded-b:last-child {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.last\\:rounded-b-md:last-child {
  border-bottom-right-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.last\\:rounded-b-lg:last-child {
  border-bottom-right-radius: var(--radius);
  border-bottom-left-radius: var(--radius);
}
.last\\:rounded-b-full:last-child {
  border-bottom-right-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.last\\:rounded-r:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.last\\:rounded-r-md:last-child {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.last\\:rounded-r-lg:last-child {
  border-top-right-radius: var(--radius);
  border-bottom-right-radius: var(--radius);
}
.last\\:rounded-r-full:last-child {
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.last\\:rounded-r-sm:last-child {
  border-top-right-radius: calc(var(--radius) - 4px);
  border-bottom-right-radius: calc(var(--radius) - 4px);
}
.last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}
.last\\:border-r-0:last-child {
  border-right-width: 0px;
}
.last\\:border-b:last-child {
  border-bottom-width: 1px;
}
.last\\:border-r:last-child {
  border-right-width: 1px;
}
.last\\:border-l-0:last-child {
  border-left-width: 0px;
}
.focus-within\\:relative[focus-within] {
  position: relative;
}
.focus-within\\:relative:focus-within {
  position: relative;
}
.focus-within\\:z-20[focus-within] {
  z-index: 20;
}
.focus-within\\:z-20:focus-within {
  z-index: 20;
}
.hover\\:cursor-pointer:hover {
  cursor: pointer;
}
.hover\\:rounded:hover {
  border-radius: 0.25rem;
}
.hover\\:border-primary-light:hover {
  --tw-border-opacity: 1;
  border-color: rgba(112, 169, 235, var(--tw-border-opacity));
}
.hover\\:border-highlight:hover {
  border-color: hsl(var(--highlight));
}
.hover\\:border-black:hover {
  --tw-border-opacity: 1;
  border-color: rgba(0, 0, 0, var(--tw-border-opacity));
}
.hover\\:border-primary-dark:hover {
  --tw-border-opacity: 1;
  border-color: rgba(9, 12, 41, var(--tw-border-opacity));
}
.hover\\:border-gray-500:hover {
  --tw-border-opacity: 1;
  border-color: rgba(160, 174, 192, var(--tw-border-opacity));
}
.hover\\:border-secondary-light:hover {
  --tw-border-opacity: 1;
  border-color: rgba(58, 63, 153, var(--tw-border-opacity));
}
.hover\\:border-blue-300:hover {
  --tw-border-opacity: 1;
  border-color: rgba(144, 205, 244, var(--tw-border-opacity));
}
.hover\\:\\!bg-primary-dark:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(9, 12, 41, var(--tw-bg-opacity)) !important;
}
.hover\\:bg-transparent:hover {
  background-color: transparent;
}
.hover\\:bg-primary-dark:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(9, 12, 41, var(--tw-bg-opacity));
}
.hover\\:bg-secondary-main:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(43, 22, 107, var(--tw-bg-opacity));
}
.hover\\:bg-accent:hover {
  background-color: hsl(var(--accent));
}
.hover\\:bg-primary\\/30:hover {
  background-color: hsl(var(--primary) / .30);
}
.hover\\:bg-primary-light:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(112, 169, 235, var(--tw-bg-opacity));
}
.hover\\:bg-customblue-80:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(20, 84, 212, var(--tw-bg-opacity));
}
.hover\\:bg-customblue-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(15, 58, 148, var(--tw-bg-opacity));
}
.hover\\:bg-customblue-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(29, 32, 77, var(--tw-bg-opacity));
}
.hover\\:bg-secondary-dark:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(10, 34, 64, var(--tw-bg-opacity));
}
.hover\\:bg-primary-main:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(9, 68, 179, var(--tw-bg-opacity));
}
.hover\\:bg-secondary-light:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(58, 63, 153, var(--tw-bg-opacity));
}
.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
.hover\\:bg-black:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
}
.hover\\:bg-gray-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(26, 32, 44, var(--tw-bg-opacity));
}
.hover\\:bg-secondary-light\\/60:hover {
  background-color: rgba(58, 63, 153, .60);
}
.hover\\:bg-primary\\/100:hover {
  background-color: hsl(var(--primary) / 1);
}
.hover\\:bg-destructive\\/90:hover {
  background-color: hsl(var(--destructive) / .90);
}
.hover\\:bg-primary\\/25:hover {
  background-color: hsl(var(--primary) / .25);
}
.hover\\:bg-primary\\/60:hover {
  background-color: hsl(var(--primary) / .60);
}
.hover\\:bg-primary\\/80:hover {
  background-color: hsl(var(--primary) / .80);
}
.hover\\:bg-primary\\/20:hover {
  background-color: hsl(var(--primary) / .20);
}
.hover\\:bg-primary\\/10:hover {
  background-color: hsl(var(--primary) / .10);
}
.hover\\:bg-background:hover {
  background-color: hsl(var(--background));
}
.hover\\:\\!bg-highlight\\/80:hover {
  background-color: hsl(var(--highlight) / .80) !important;
}
.hover\\:\\!text-primary-light:hover {
  --tw-text-opacity: 1 !important;
  color: rgba(112, 169, 235, var(--tw-text-opacity)) !important;
}
.hover\\:text-primary-light:hover {
  --tw-text-opacity: 1;
  color: rgba(112, 169, 235, var(--tw-text-opacity));
}
.hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.hover\\:text-primary-active:hover {
  --tw-text-opacity: 1;
  color: rgba(52, 140, 253, var(--tw-text-opacity));
}
.hover\\:text-primary:hover {
  color: hsl(var(--primary));
}
.hover\\:text-primary-foreground:hover {
  color: hsl(var(--primary-foreground));
}
.hover\\:text-highlight:hover {
  color: hsl(var(--highlight));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:opacity-80:hover {
  opacity: .80;
}
.hover\\:opacity-70:hover {
  opacity: .70;
}
.hover\\:opacity-60:hover {
  opacity: .60;
}
.hover\\:opacity-100:hover {
  opacity: 1;
}
.focus\\:\\!rounded-md:focus {
  border-radius: calc(var(--radius) - 2px) !important;
}
.focus\\:border-none:focus {
  border-style: none;
}
.focus\\:border-black:focus {
  --tw-border-opacity: 1;
  border-color: rgba(0, 0, 0, var(--tw-border-opacity));
}
.focus\\:border-inputfield-focus:focus {
  --tw-border-opacity: 1;
  border-color: rgba(90, 204, 230, var(--tw-border-opacity));
}
.focus\\:\\!border-primary-light:focus {
  --tw-border-opacity: 1 !important;
  border-color: rgba(112, 169, 235, var(--tw-border-opacity)) !important;
}
.focus\\:border-gray-500:focus {
  --tw-border-opacity: 1;
  border-color: rgba(160, 174, 192, var(--tw-border-opacity));
}
.focus\\:border-inputfield-main:focus {
  --tw-border-opacity: 1;
  border-color: rgba(58, 63, 153, var(--tw-border-opacity));
}
.focus\\:border-blue-300:focus {
  --tw-border-opacity: 1;
  border-color: rgba(144, 205, 244, var(--tw-border-opacity));
}
.focus\\:bg-secondary-dark:focus {
  --tw-bg-opacity: 1;
  background-color: rgba(10, 34, 64, var(--tw-bg-opacity));
}
.focus\\:\\!bg-primary-light:focus {
  --tw-bg-opacity: 1 !important;
  background-color: rgba(112, 169, 235, var(--tw-bg-opacity)) !important;
}
.focus\\:bg-primary-main:focus {
  --tw-bg-opacity: 1;
  background-color: rgba(9, 68, 179, var(--tw-bg-opacity));
}
.focus\\:bg-secondary-light:focus {
  --tw-bg-opacity: 1;
  background-color: rgba(58, 63, 153, var(--tw-bg-opacity));
}
.focus\\:bg-white:focus {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
.focus\\:bg-black:focus {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
}
.focus\\:bg-primary-light:focus {
  --tw-bg-opacity: 1;
  background-color: rgba(112, 169, 235, var(--tw-bg-opacity));
}
.focus\\:bg-primary\\/80:focus {
  background-color: hsl(var(--primary) / .80);
}
.focus\\:bg-accent:focus {
  background-color: hsl(var(--accent));
}
.focus\\:text-black:focus {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
.focus\\:text-white:focus {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.focus\\:\\!text-black:focus {
  --tw-text-opacity: 1 !important;
  color: rgba(0, 0, 0, var(--tw-text-opacity)) !important;
}
.focus\\:text-primary-foreground:focus {
  color: hsl(var(--primary-foreground));
}
.focus\\:text-accent-foreground:focus {
  color: hsl(var(--accent-foreground));
}
.focus\\:opacity-80:focus {
  opacity: .80;
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.focus\\:ring-ring:focus {
  --tw-ring-color: hsl(var(--ring));
}
.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:outline-none.focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-1.focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.focus-visible\\:ring-1.focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.focus-visible\\:ring-1.focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.focus-visible\\:ring-1:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.focus-visible\\:ring-2.focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.focus-visible\\:ring-2.focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.focus-visible\\:ring-2.focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
  -webkit-box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
          box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0));
}
.focus-visible\\:ring-ring.focus-visible {
  --tw-ring-color: hsl(var(--ring));
}
.focus-visible\\:ring-ring:focus-visible {
  --tw-ring-color: hsl(var(--ring));
}
.focus-visible\\:ring-offset-1.focus-visible {
  --tw-ring-offset-width: 1px;
}
.focus-visible\\:ring-offset-1:focus-visible {
  --tw-ring-offset-width: 1px;
}
.focus-visible\\:ring-offset-2.focus-visible {
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-background.focus-visible {
  --tw-ring-offset-color: hsl(var(--background));
}
.focus-visible\\:ring-offset-background:focus-visible {
  --tw-ring-offset-color: hsl(var(--background));
}
.active\\:border-white:active {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}
.active\\:bg-secondary-dark:active {
  --tw-bg-opacity: 1;
  background-color: rgba(10, 34, 64, var(--tw-bg-opacity));
}
.active\\:bg-customblue-40:active {
  --tw-bg-opacity: 1;
  background-color: rgba(14, 48, 127, var(--tw-bg-opacity));
}
.active\\:bg-customblue-20:active {
  --tw-bg-opacity: 1;
  background-color: rgba(11, 31, 84, var(--tw-bg-opacity));
}
.active\\:text-aqua-pale:active {
  --tw-text-opacity: 1;
  color: rgba(123, 178, 206, var(--tw-text-opacity));
}
.active\\:text-foreground:active {
  color: hsl(var(--foreground));
}
.active\\:text-primary-light:active {
  --tw-text-opacity: 1;
  color: rgba(112, 169, 235, var(--tw-text-opacity));
}
.active\\:text-white:active {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.active\\:opacity-80:active {
  opacity: .80;
}
.active\\:opacity-100:active {
  opacity: 1;
}
.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:border-inputfield-disabled:disabled {
  --tw-border-opacity: 1;
  border-color: rgba(43, 22, 107, var(--tw-border-opacity));
}
.disabled\\:opacity-50:disabled {
  opacity: .50;
}
.group\\/pane:hover .group-hover\\/pane\\:visible {
  visibility: visible;
}
.group:hover .group-hover\\:visible {
  visibility: visible;
}
.group:hover .group-hover\\:block {
  display: block;
}
.group\\/row:hover .group-hover\\/row\\:flex {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.group:hover .group-hover\\:inline-flex {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}
.group\\/row:hover .group-hover\\/row\\:hidden {
  display: none;
}
.group:hover .group-hover\\:hidden {
  display: none;
}
.group:hover .group-hover\\:cursor-pointer {
  cursor: pointer;
}
.group:hover .group-hover\\:border-black {
  --tw-border-opacity: 1;
  border-color: rgba(0, 0, 0, var(--tw-border-opacity));
}
.group\\/button:hover .group-hover\\/button\\:border-primary-dark {
  --tw-border-opacity: 1;
  border-color: rgba(9, 12, 41, var(--tw-border-opacity));
}
.group\\/pane:hover .group-hover\\/pane\\:border-primary-light\\/70 {
  border-color: rgba(112, 169, 235, .70);
}
.group:hover .group-hover\\:border-highlight\\/50 {
  border-color: hsl(var(--highlight) / .50);
}
.group:hover .group-hover\\:bg-primary-main {
  --tw-bg-opacity: 1;
  background-color: rgba(9, 68, 179, var(--tw-bg-opacity));
}
.group:hover .group-hover\\:bg-secondary-main {
  --tw-bg-opacity: 1;
  background-color: rgba(43, 22, 107, var(--tw-bg-opacity));
}
.group:hover .group-hover\\:bg-secondary-dark {
  --tw-bg-opacity: 1;
  background-color: rgba(10, 34, 64, var(--tw-bg-opacity));
}
.group:hover .group-hover\\:text-primary-light {
  --tw-text-opacity: 1;
  color: rgba(112, 169, 235, var(--tw-text-opacity));
}
.group\\/button:hover .group-hover\\/button\\:text-primary-light {
  --tw-text-opacity: 1;
  color: rgba(112, 169, 235, var(--tw-text-opacity));
}
.group\\/secondary:hover .group-hover\\/secondary\\:text-primary-light {
  --tw-text-opacity: 1;
  color: rgba(112, 169, 235, var(--tw-text-opacity));
}
.group:hover .group-hover\\:text-primary {
  color: hsl(var(--primary));
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
.peer:disabled ~ .peer-disabled\\:cursor-not-allowed {
  cursor: not-allowed;
}
.peer:disabled ~ .peer-disabled\\:opacity-70 {
  opacity: .70;
}
.aria-selected\\:bg-accent\\/50[aria-selected="true"] {
  background-color: hsl(var(--accent) / .50);
}
.aria-selected\\:bg-accent[aria-selected="true"] {
  background-color: hsl(var(--accent));
}
.aria-selected\\:bg-primary\\/30[aria-selected="true"] {
  background-color: hsl(var(--primary) / .30);
}
.aria-selected\\:text-muted-foreground[aria-selected="true"] {
  color: hsl(var(--muted-foreground));
}
.aria-selected\\:text-accent-foreground[aria-selected="true"] {
  color: hsl(var(--accent-foreground));
}
.aria-selected\\:opacity-100[aria-selected="true"] {
  opacity: 1;
}
.aria-selected\\:opacity-30[aria-selected="true"] {
  opacity: .30;
}
.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled=true] {
  pointer-events: none;
}
.data-\\[disabled\\]\\:pointer-events-none[data-disabled] {
  pointer-events: none;
}
.data-\\[state\\=open\\]\\:inline-flex[data-state=open] {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}
.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction=vertical] {
  height: 1px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction=vertical] {
  width: 100%;
}
.data-\\[side\\=bottom\\]\\:translate-y-1[data-side=bottom] {
  --tw-translate-y: 0.25rem;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=left\\]\\:-translate-x-1[data-side=left] {
  --tw-translate-x: -0.25rem;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=right\\]\\:translate-x-1[data-side=right] {
  --tw-translate-x: 0.25rem;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=top\\]\\:-translate-y-1[data-side=top] {
  --tw-translate-y: -0.25rem;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=checked\\]\\:translate-x-3[data-state=checked] {
  --tw-translate-x: 0.75rem;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state=unchecked] {
  --tw-translate-x: 0px;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@-webkit-keyframes accordion-up {
  from {
    height: var(--radix-accordion-content-height);
  }
  to {
    height: 0;
  }
}
@keyframes accordion-up {
  from {
    height: var(--radix-accordion-content-height);
  }
  to {
    height: 0;
  }
}
.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state=closed] {
  -webkit-animation: accordion-up 0.2s ease-out;
          animation: accordion-up 0.2s ease-out;
}
@-webkit-keyframes accordion-down {
  from {
    height: 0;
  }
  to {
    height: var(--radix-accordion-content-height);
  }
}
@keyframes accordion-down {
  from {
    height: 0;
  }
  to {
    height: var(--radix-accordion-content-height);
  }
}
.data-\\[state\\=open\\]\\:animate-accordion-down[data-state=open] {
  -webkit-animation: accordion-down 0.2s ease-out;
          animation: accordion-down 0.2s ease-out;
}
.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction=vertical] {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}
.data-\\[state\\=checked\\]\\:bg-primary[data-state=checked] {
  background-color: hsl(var(--primary));
}
.data-\\[state\\=open\\]\\:bg-accent[data-state=open] {
  background-color: hsl(var(--accent));
}
.data-\\[state\\=unchecked\\]\\:bg-primary\\/30[data-state=unchecked] {
  background-color: hsl(var(--primary) / .30);
}
.data-\\[state\\=active\\]\\:bg-primary\\/30[data-state=active] {
  background-color: hsl(var(--primary) / .30);
}
.data-\\[state\\=on\\]\\:bg-primary\\/20[data-state=on] {
  background-color: hsl(var(--primary) / .20);
}
.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state=checked] {
  color: hsl(var(--primary-foreground));
}
.data-\\[state\\=open\\]\\:text-accent-foreground[data-state=open] {
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-muted-foreground[data-state=open] {
  color: hsl(var(--muted-foreground));
}
.data-\\[state\\=on\\]\\:text-highlight[data-state=on] {
  color: hsl(var(--highlight));
}
.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled=true] {
  opacity: .50;
}
.data-\\[disabled\\]\\:opacity-50[data-disabled] {
  opacity: .50;
}
.data-\\[state\\=active\\]\\:shadow[data-state=active] {
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px 0 var(--tw-shadow-color);
  -webkit-box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
          box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
          box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.data-\\[state\\=open\\]\\:animate-in[data-state=open] {
  -webkit-animation-name: enter;
          animation-name: enter;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:animate-out[data-state=closed] {
  -webkit-animation-name: exit;
          animation-name: exit;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:fade-out-0[data-state=closed] {
  --tw-exit-opacity: 0;
}
.data-\\[state\\=open\\]\\:fade-in-0[data-state=open] {
  --tw-enter-opacity: 0;
}
.data-\\[state\\=closed\\]\\:zoom-out-95[data-state=closed] {
  --tw-exit-scale: .95;
}
.data-\\[state\\=open\\]\\:zoom-in-95[data-state=open] {
  --tw-enter-scale: .95;
}
.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side=bottom] {
  --tw-enter-translate-y: -0.5rem;
}
.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side=left] {
  --tw-enter-translate-x: 0.5rem;
}
.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side=right] {
  --tw-enter-translate-x: -0.5rem;
}
.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side=top] {
  --tw-enter-translate-y: 0.5rem;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state=closed] {
  --tw-exit-translate-x: -50%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state=closed] {
  --tw-exit-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state=open] {
  --tw-enter-translate-x: -50%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state=open] {
  --tw-enter-translate-y: -48%;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction=vertical]::after {
  content: var(--tw-content);
  left: 0;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction=vertical]::after {
  content: var(--tw-content);
  height: 0.25rem;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction=vertical]::after {
  content: var(--tw-content);
  width: 100%;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction=vertical]::after {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction=vertical]::after {
  content: var(--tw-content);
  --tw-translate-x: 0px;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:data-\\[state\\=unchecked\\]\\:bg-primary\\/40[data-state=unchecked]:hover {
  background-color: hsl(var(--primary) / .40);
}
@media (min-width: 640px) {
  .sm\\:w-24 {
    width: 6rem;
  }
  .sm\\:flex-\\[7\\] {
    -webkit-box-flex: 7;
        -ms-flex: 7;
            flex: 7;
  }
  .sm\\:flex-\\[3\\] {
    -webkit-box-flex: 3;
        -ms-flex: 3;
            flex: 3;
  }
  .sm\\:flex-row {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
        -ms-flex-direction: row;
            flex-direction: row;
  }
  .sm\\:justify-end {
    -webkit-box-pack: end;
        -ms-flex-pack: end;
            justify-content: flex-end;
  }
  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * (1 - var(--tw-space-x-reverse)));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * (1 - var(--tw-space-y-reverse)));
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }
  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * (1 - var(--tw-space-x-reverse)));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .sm\\:rounded-lg {
    border-radius: var(--radius);
  }
  .sm\\:text-left {
    text-align: left;
  }
}
@media (min-width: 768px) {
  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 1024px) {
  .lg\\:w-10\\/12 {
    width: 83.333333%;
  }
  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (min-width: 1280px) {
  .xl\\:w-9\\/12 {
    width: 75%;
  }
  .xl\\:min-w-\\[284px\\] {
    min-width: 284px;
  }
  .xl\\:max-w-\\[246px\\] {
    max-width: 246px;
  }
}
.\\[\\&\\[data-state\\=closed\\]\\>svg\\]\\:rotate-90[data-state=closed]>svg {
  --tw-rotate: 90deg;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md[\\:has\\(\\[aria-selected\\].day-range-end\\)] {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end) {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50[\\:has\\(\\[aria-selected\\].day-outside\\)] {
  background-color: hsl(var(--accent) / .50);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside) {
  background-color: hsl(var(--accent) / .50);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent[\\:has\\(\\[aria-selected\\]\\)] {
  background-color: hsl(var(--accent));
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]) {
  background-color: hsl(var(--accent));
}
.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md[\\:has\\(\\[aria-selected\\]\\)]:first-child {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md[\\:has\\(\\[aria-selected\\]\\)]:last-child {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading] {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-sm [cmdk-group-heading] {
  font-size: 0.75rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading] {
  font-weight: 500;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading] {
  color: hsl(var(--muted-foreground));
}
.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group] {
  padding-top: 0px;
}
.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg {
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg {
  width: 1.25rem;
}
.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input] {
  height: 3rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item] {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg {
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg {
  width: 1.25rem;
}
.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div {
  --tw-rotate: 90deg;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\[data-resize-handle-state\\=\\'hover\\'\\]\\]\\:bg-primary\\/40[data-resize-handle-state='hover'] {
  background-color: hsl(var(--primary) / .40);
}
.\\[\\&\\[data-resize-handle-state\\=\\'drag\\'\\]\\]\\:bg-primary\\/40[data-resize-handle-state='drag'] {
  background-color: hsl(var(--primary) / .40);
}
`, "",{"version":3,"sources":["webpack://./../../ui-next/src/assets/fonts.css","webpack://./../../ui-next/src/tailwind.css"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAoD;EACpD;+FAC6F;AAC/F;AACA,UAAU;AACV;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAoD;EACpD;+FAC6F;AAC/F;AACA,UAAU;AACV;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAoD;EACpD;+FAC6F;AAC/F;AACA,UAAU;AACV;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAoD;EACpD;+FAC6F;AAC/F;AACA,UAAU;AACV;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAoD;EACpD;+FAC6F;AAC/F;AC/CA,iEAAc;AAAd;;;CAAc;AAAd;;;EAAA,8BAAc;UAAd,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;EAAA,gBAAc;AAAA;AAAd;;;;;;CAAc;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,gBAAc;IAAd,cAAc;OAAd,WAAc,EAAd,MAAc;EAAd,gRAAc,EAAd,MAAc;EAAd,qCAAc;UAAd,6BAAc,EAAd,MAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,0BAAc;EAAd,sDAAc;UAAd,8CAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,mBAAc;AAAA;AAAd;;;CAAc;AAAd;;;;EAAA,iFAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;AAAd;EAAA,eAAc;AAAA;AAAd;EAAA,WAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,oBAAc;AAAA;AAAd;;;CAAc;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,aAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,YAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,kBAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;AAAd;EAAA,UAAc;AAAA;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAAd;IAAA,wBAAc;IAAd,sBAAc;IAAd,wBAAc;IAAd,sBAAc;IAAd,mBAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,wBAAc;IAAd,8BAAc;IAAd,wBAAc;IAAd,mCAAc;IAAd,qBAAc;IAAd,+BAAc;IAAd,qBAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,kCAAc;IAAd,oBAAc;IAAd,oBAAc;IAAd,mBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,gBAAc;IAAd,gCAAc;IAAd,oCAAc;IAAd,mCAAc;;IAAd,8BAAc;IAAd,iCAAc;IAAd,+BAAc;;IAAd,gCAAc;IAAd,mCAAc;IAAd,iCAAc;;IAAd,+BAAc;IAAd,mCAAc;IAAd,iCAAc;EAAA;AAAd;IAAA,uBAAc;IAAd,sBAAc;IAAd,mBAAc;IAAd,2BAAc;IAAd,oBAAc;IAAd,8BAAc;IAAd,wBAAc;IAAd,8BAAc;IAAd,uBAAc;IAAd,gCAAc;IAAd,mBAAc;IAAd,8BAAc;IAAd,oBAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,kCAAc;IAAd,oBAAc;IAAd,oBAAc;IAAd,mBAAc;IAAd,sBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,sBAAc;IAAd,sBAAc;EAAA;AAAd;IAAA,gCAAc;EAAA;AAAd;EAAA,6BAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wCAAc;EAAd,0CAAc;EAAd,mCAAc;EAAd,8BAAc;EAAd,sCAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,MAAmB;EAAnB,QAAmB;EAAnB,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,MAAmB;EAAnB;AAAmB;AAAnB;EAAA,UAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;MAAnB,oBAAmB;UAAnB;AAAmB;AAAnB;EAAA,gCAAmB;MAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;UAAnB;AAAmB;AAAnB;EAAA,+BAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;MAAnB,gBAAmB;UAAnB;AAAmB;AAAnB;EAAA,mBAAmB;MAAnB,kBAAmB;UAAnB;AAAmB;AAAnB;EAAA,mBAAmB;MAAnB,kBAAmB;UAAnB;AAAmB;AAAnB;EAAA,mBAAmB;MAAnB,kBAAmB;UAAnB;AAAmB;AAAnB;EAAA,mBAAmB;MAAnB,cAAmB;UAAnB;AAAmB;AAAnB;EAAA,oBAAmB;MAAnB;AAAmB;AAAnB;EAAA,oBAAmB;MAAnB;AAAmB;AAAnB;EAAA,oBAAmB;MAAnB;AAAmB;AAAnB;EAAA,oBAAmB;MAAnB;AAAmB;AAAnB;EAAA,mBAAmB;MAAnB,oBAAmB;UAAnB;AAAmB;AAAnB;EAAA,mBAAmB;MAAnB,oBAAmB;UAAnB;AAAmB;AAAnB;EAAA,mBAAmB;MAAnB,oBAAmB;UAAnB;AAAmB;AAAnB;EAAA,8BAAmB;MAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;UAAnB;AAAmB;AAAnB;EAAA,kCAAmB;UAAnB;AAAmB;AAAnB;EAAA,6BAAmB;UAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,uMAAmB;UAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,uMAAmB;UAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,uMAAmB;UAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,uMAAmB;UAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,uMAAmB;UAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uMAAmB;UAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,uMAAmB;UAAnB;AAAmB;AAAnB;EAAA,uMAAmB;UAAnB;AAAmB;AAAnB;EAAA;IAAA,iCAAmB;YAAnB;EAAmB;AAAA;AAAnB;EAAA;IAAA,iCAAmB;YAAnB;EAAmB;AAAA;AAAnB;EAAA,0CAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;MAAnB;AAAmB;AAAnB;EAAA,yBAAmB;aAAnB,sBAAmB;cAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA,yBAAmB;aAAnB,sBAAmB;cAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,6BAAmB;MAAnB,uBAAmB;UAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,wCAAmB;MAAnB,kCAAmB;UAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,8BAAmB;MAAnB,+BAAmB;UAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,6BAAmB;MAAnB,0BAAmB;UAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,8BAAmB;MAAnB,kCAAmB;UAAnB;AAAmB;AAAnB;EAAA,mBAAmB;MAAnB;AAAmB;AAAnB;EAAA,qBAAmB;MAAnB;AAAmB;AAAnB;EAAA,wBAAmB;MAAnB,qBAAmB;UAAnB,kBAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;MAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA,sBAAmB;MAAnB,mBAAmB;UAAnB;AAAmB;AAAnB;EAAA,yBAAmB;MAAnB,sBAAmB;UAAnB;AAAmB;AAAnB;EAAA,oCAAmB;MAAnB,iCAAmB;UAAnB;AAAmB;AAAnB;EAAA,2BAAmB;MAAnB,wBAAmB;UAAnB;AAAmB;AAAnB;EAAA,0BAAmB;MAAnB,uBAAmB;UAAnB;AAAmB;AAAnB;EAAA,uBAAmB;MAAnB,oBAAmB;UAAnB;AAAmB;AAAnB;EAAA,qBAAmB;MAAnB,kBAAmB;UAAnB;AAAmB;AAAnB;EAAA,wBAAmB;MAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA,mCAAmB;MAAnB,gCAAmB;UAAnB;AAAmB;AAAnB;EAAA,yBAAmB;MAAnB,sBAAmB;UAAnB;AAAmB;AAAnB;EAAA,yBAAmB;MAAnB;AAAmB;AAAnB;EAAA,8BAAmB;MAAnB,2BAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,0DAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;MAAnB;AAAmB;AAAnB;EAAA,wBAAmB;MAAnB;AAAmB;AAAnB;EAAA,2BAAmB;MAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,4CAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4EAAmB;EAAnB,2FAAmB;EAAnB,0EAAmB;UAAnB,kEAAmB;EAAnB,+HAAmB;UAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,sCAAmB;EAAnB,0EAAmB;UAAnB,kEAAmB;EAAnB,+HAAmB;UAAnB;AAAmB;AAAnB;EAAA,oFAAmB;EAAnB,mGAAmB;EAAnB,0EAAmB;UAAnB,kEAAmB;EAAnB,+HAAmB;UAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB,uDAAmB;EAAnB,0EAAmB;UAAnB,kEAAmB;EAAnB,+HAAmB;UAAnB;AAAmB;AAAnB;EAAA,kFAAmB;EAAnB,iGAAmB;EAAnB,0EAAmB;UAAnB,kEAAmB;EAAnB,+HAAmB;UAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB,0EAAmB;UAAnB,kEAAmB;EAAnB,+HAAmB;UAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB,0FAAmB;UAAnB,kFAAmB;EAAnB,4GAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,yLAAmB;UAAnB;AAAmB;AAAnB;EAAA,uGAAmB;EAAnB,yLAAmB;UAAnB;AAAmB;AAAnB;EAAA,uGAAmB;EAAnB,yLAAmB;UAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,yLAAmB;UAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB,yLAAmB;UAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB,oMAAmB;UAAnB;AAAmB;AAAnB;EAAA,yLAAmB;UAAnB;AAAmB;AAAnB;EAAA,oMAAmB;UAAnB;AAAmB;AAAnB;EAAA,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,sCAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gIAAmB;EAAnB,wHAAmB;EAAnB,wGAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB;AAAmB;AAAnB;EAAA,2IAAmB;EAAnB,mIAAmB;EAAnB,mHAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;UAAnB;AAAmB;AAAnB;EAAA,kCAAmB;UAAnB;AAAmB;AAAnB;EAAA,kCAAmB;UAAnB;AAAmB;AAAnB;EAAA,mCAAmB;UAAnB;AAAmB;AAAnB;EAAA,kCAAmB;UAAnB;AAAmB;AAAnB;EAAA,6CAAmB;UAAnB;AAAmB;AAAnB;EAAA,gEAAmB;UAAnB;AAAmB;AAAnB;EAAA,8DAAmB;UAAnB;AAAmB;AAAnB;EAAA,8DAAmB;UAAnB;AAAmB;AAAnB;EAAA,2EAAmB;UAAnB;AAAmB;AAAnB;EAAA;IAAA,UAAmB;IAAnB,mCAAmB;IAAnB,kEAAmB;YAAnB,0DAAmB;IAAnB,yNAAmB;YAAnB;EAAmB;AAAA;AAAnB;EAAA;IAAA,UAAmB;IAAnB,mCAAmB;IAAnB,kEAAmB;YAAnB,0DAAmB;IAAnB,yNAAmB;YAAnB;EAAmB;AAAA;AAAnB;EAAA;IAAA,UAAmB;IAAnB,kCAAmB;IAAnB,kEAAmB;YAAnB,0DAAmB;IAAnB,mNAAmB;YAAnB;EAAmB;AAAA;AAAnB;EAAA;IAAA,UAAmB;IAAnB,kCAAmB;IAAnB,kEAAmB;YAAnB,0DAAmB;IAAnB,mNAAmB;YAAnB;EAAmB;AAAA;AAAnB;EAAA,6BAAmB;UAAnB,qBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;UAAnB;AAAmB;AAAnB;EAAA,iCAAmB;UAAnB;AAAmB;AAAnB;EAAA,iCAAmB;UAAnB;AAAmB;AAAnB;EAAA,kCAAmB;UAAnB;AAAmB;AAAnB;EAAA,iCAAmB;UAAnB;AAAmB;AAAnB;EAAA,4CAAmB;UAAnB;AAAmB;AAAnB;EAAA,+DAAmB;UAAnB;AAAmB;AAAnB;EAAA,6DAAmB;UAAnB;AAAmB;AAAnB;EAAA,6DAAmB;UAAnB;AAAmB;AAAnB;EAAA,0EAAmB;UAAnB;AAAmB;AAAnB;EAAA,qCAAmB;UAAnB;AAAmB;AAAnB;EAAA,oCAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAEnB,eAAe;AA4Ef;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA8DC;AAED;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA2DC;AAED,mCAAmC;AAajC;EAAA,iBAA2C;EAA3C,oBAA2C;EAA3C,iBAA2C;EAA3C,gBAA2C;EAA3C,oBAA2C;EAA3C;AAA2C;AAI3C;EAAA,oBAA8B;EAA9B,uBAA8B;EAA9B,eAA8B;EAA9B,oBAA8B;EAA9B;AAA8B;AAI9B;EAAA,qBAA2D;EAA3D,oBAA2D;EAA3D,oBAA2D;EAA3D,aAA2D;EAA3D,8BAA2D;EAA3D,6BAA2D;MAA3D,uBAA2D;UAA3D,mBAA2D;EAA3D,mBAA2D;MAA3D,eAA2D;EAA3D,wCAA2D;EAA3D,iBAA2D;EAA3D,mBAA2D;EAA3D;AAA2D;AAI3D;EAAA,mBAAwB;MAAxB,kBAAwB;UAAxB,cAAwB;EAAxB,oBAAwB;EAAxB;AAAwB;AAIxB;EAAA,mBAAwB;MAAxB,kBAAwB;UAAxB,cAAwB;EAAxB,kBAAwB;EAAxB;AAAwB;AAG1B,uCAAuC;AAEvC,YAAY;AAEZ;EACE,iCAAyB;UAAzB,yBAAyB;AAC3B;AAEA,mDAAmD;AAGjD;;EAAA,wBAAsB;UAAtB;AAAsB;AAGxB;EACE,0BAA0B,EAAE,gBAAgB;AAC9C;AA/PA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,0BAgQA;EAhQA;AAgQA;AAhQA;EAAA,0BAgQA;EAhQA,MAgQA;EAhQA;AAgQA;AAhQA;EAAA,0BAgQA;EAhQA;AAgQA;AAhQA;EAAA,0BAgQA;EAhQA;AAgQA;AAhQA;EAAA,0BAgQA;EAhQA,sBAgQA;EAhQA,uMAgQA;UAhQA;AAgQA;AAhQA;EAAA,+BAgQA;EAhQA;AAgQA;AAhQA;EAAA,iDAgQA;EAhQA;AAgQA;AAhQA;EAAA,qCAgQA;EAhQA;AAgQA;AAhQA;EAAA,8BAgQA;EAhQA;AAgQA;AAhQA;EAAA,+BAgQA;EAhQA;AAgQA;AAhQA;EAAA,iDAgQA;EAhQA;AAgQA;AAhQA;EAAA,qCAgQA;EAhQA;AAgQA;AAhQA;EAAA,8BAgQA;EAhQA;AAgQA;AAhQA;EAAA,iDAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,mCAgQA;EAhQA;AAgQA;AAhQA;EAAA,qDAgQA;EAhQA;AAgQA;AAhQA;EAAA,yCAgQA;EAhQA;AAgQA;AAhQA;EAAA,kCAgQA;EAhQA;AAgQA;AAhQA;EAAA,gCAgQA;EAhQA;AAgQA;AAhQA;EAAA,kDAgQA;EAhQA;AAgQA;AAhQA;EAAA,sCAgQA;EAhQA;AAgQA;AAhQA;EAAA,+BAgQA;EAhQA;AAgQA;AAhQA;EAAA,kDAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,6BAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,+BAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,iCAgQA;EAhQA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,6BAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,+BAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,8BAgQA;EAhQA;AAgQA;AAhQA;EAAA,2GAgQA;EAhQA,yGAgQA;EAhQA,0FAgQA;UAhQA,kFAgQA;EAhQA,4GAgQA;UAhQA;AAgQA;AAhQA;EAAA,2GAgQA;EAhQA,yGAgQA;EAhQA,0FAgQA;UAhQA,kFAgQA;EAhQA,4GAgQA;UAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,8BAgQA;EAhQA;AAgQA;AAhQA;EAAA,8BAgQA;EAhQA;AAgQA;AAhQA;EAAA,2GAgQA;EAhQA,yGAgQA;EAhQA,0FAgQA;UAhQA,kFAgQA;EAhQA,4GAgQA;UAhQA;AAgQA;AAhQA;EAAA,2GAgQA;EAhQA,yGAgQA;EAhQA,0FAgQA;UAhQA,kFAgQA;EAhQA,4GAgQA;UAhQA;AAgQA;AAhQA;EAAA,2GAgQA;EAhQA,yGAgQA;EAhQA,0FAgQA;UAhQA,kFAgQA;EAhQA,4GAgQA;UAhQA;AAgQA;AAhQA;EAAA,2GAgQA;EAhQA,yGAgQA;EAhQA,0FAgQA;UAhQA,kFAgQA;EAhQA,4GAgQA;UAhQA;AAgQA;AAhQA;EAAA,2GAgQA;EAhQA,yGAgQA;EAhQA,0FAgQA;UAhQA,kFAgQA;EAhQA,4GAgQA;UAhQA;AAgQA;AAhQA;EAAA,2GAgQA;EAhQA,yGAgQA;EAhQA,0FAgQA;UAhQA,kFAgQA;EAhQA,4GAgQA;UAhQA;AAgQA;AAhQA;EAAA,2GAgQA;EAhQA,yGAgQA;EAhQA,0FAgQA;UAhQA,kFAgQA;EAhQA,4GAgQA;UAhQA;AAgQA;AAhQA;EAAA,2GAgQA;EAhQA,yGAgQA;EAhQA,0FAgQA;UAhQA,kFAgQA;EAhQA,4GAgQA;UAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,2BAgQA;EAhQA,2BAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA,sBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,2BAgQA;EAhQA,2BAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,yBAgQA;EAhQA,uMAgQA;UAhQA;AAgQA;AAhQA;EAAA,0BAgQA;EAhQA,uMAgQA;UAhQA;AAgQA;AAhQA;EAAA,yBAgQA;EAhQA,uMAgQA;UAhQA;AAgQA;AAhQA;EAAA,0BAgQA;EAhQA,uMAgQA;UAhQA;AAgQA;AAhQA;EAAA,yBAgQA;EAhQA,uMAgQA;UAhQA;AAgQA;AAhQA;EAAA,qBAgQA;EAhQA,uMAgQA;UAhQA;AAgQA;AAhQA;EAAA;IAAA;EAgQA;EAhQA;IAAA;EAgQA;AAAA;AAhQA;EAAA;IAAA;EAgQA;EAhQA;IAAA;EAgQA;AAAA;AAhQA;EAAA,6CAgQA;UAhQA;AAgQA;AAhQA;EAAA;IAAA;EAgQA;EAhQA;IAAA;EAgQA;AAAA;AAhQA;EAAA;IAAA;EAgQA;EAhQA;IAAA;EAgQA;AAAA;AAhQA;EAAA,+CAgQA;UAhQA;AAgQA;AAhQA;EAAA,4BAgQA;EAhQA,6BAgQA;MAhQA,0BAgQA;UAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,4EAgQA;EAhQA,2FAgQA;EAhQA,0EAgQA;UAhQA,kEAgQA;EAhQA,+HAgQA;UAhQA;AAgQA;AAhQA;EAAA,6BAgQA;UAhQA,qBAgQA;EAhQA,2BAgQA;EAhQA,yBAgQA;EAhQA,0BAgQA;EAhQA,+BAgQA;EAhQA;AAgQA;AAhQA;EAAA,4BAgQA;UAhQA,oBAgQA;EAhQA,0BAgQA;EAhQA,wBAgQA;EAhQA,yBAgQA;EAhQA,8BAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,0BAgQA;EAhQA;AAgQA;AAhQA;EAAA,0BAgQA;EAhQA;AAgQA;AAhQA;EAAA,0BAgQA;EAhQA;AAgQA;AAhQA;EAAA,0BAgQA;EAhQA,sBAgQA;EAhQA,uMAgQA;UAhQA;AAgQA;AAhQA;EAAA,0BAgQA;EAhQA,qBAgQA;EAhQA,uMAgQA;UAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;IAAA;EAgQA;EAhQA;IAAA,mBAgQA;QAhQA,WAgQA;YAhQA;EAgQA;EAhQA;IAAA,mBAgQA;QAhQA,WAgQA;YAhQA;EAgQA;EAhQA;IAAA,8BAgQA;IAhQA,6BAgQA;QAhQA,uBAgQA;YAhQA;EAgQA;EAhQA;IAAA,qBAgQA;QAhQA,kBAgQA;YAhQA;EAgQA;EAhQA;IAAA,uBAgQA;IAhQA,oDAgQA;IAhQA,yDAgQA;IAhQA;EAgQA;EAhQA;IAAA,uBAgQA;IAhQA,uDAgQA;IAhQA,2DAgQA;IAhQA;EAgQA;EAhQA;IAAA,uBAgQA;IAhQA,sDAgQA;IAhQA,2DAgQA;IAhQA;EAgQA;EAhQA;IAAA;EAgQA;EAhQA;IAAA;EAgQA;AAAA;AAhQA;EAAA;IAAA;EAgQA;AAAA;AAhQA;EAAA;IAAA;EAgQA;EAhQA;IAAA;EAgQA;AAAA;AAhQA;EAAA;IAAA;EAgQA;EAhQA;IAAA;EAgQA;EAhQA;IAAA;EAgQA;AAAA;AAhQA;EAAA,kBAgQA;EAhQA,uMAgQA;UAhQA;AAgQA;AAhQA;EAAA,kDAgQA;EAhQA;AAgQA;AAhQA;EAAA,kDAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,iDAgQA;EAhQA;AAgQA;AAhQA;EAAA,iDAgQA;EAhQA;AAgQA;AAhQA;EAAA,kDAgQA;EAhQA;AAgQA;AAhQA;EAAA,kDAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,qBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA,oBAgQA;EAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA,kBAgQA;EAhQA,uMAgQA;UAhQA;AAgQA;AAhQA;EAAA;AAgQA;AAhQA;EAAA;AAgQA","sourcesContent":["/* latin */\n@font-face {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 100;\n  font-display: swap;\n  src: url('assets/woff2/latin.woff2') format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304,\n    U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n/* latin */\n@font-face {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 300;\n  font-display: swap;\n  src: url('assets/woff2/latin.woff2') format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304,\n    U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n/* latin */\n@font-face {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url('assets/woff2/latin.woff2') format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304,\n    U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n/* latin */\n@font-face {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url('assets/woff2/latin.woff2') format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304,\n    U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n/* latin */\n@font-face {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url('assets/woff2/latin.woff2') format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304,\n    U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n","@import './assets/fonts.css';\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* OHIF Theme */\n\n@layer base {\n  :root {\n    --highlight: 191 74% 63%;\n    --neutral: 213 22% 59%;\n    --background: 236 62% 5%;\n    --foreground: 0 0% 98%;\n    --card: 234 64% 10%;\n    --card-foreground: 0 0% 98%;\n    --popover: 211 75% 16%;\n    --popover-foreground: 0 0% 98%;\n    --primary: 211, 77%, 68%;\n    --primary-foreground: 0 0% 98%;\n    --secondary: 214 66% 48%;\n    --secondary-foreground: 200 50% 84%;\n    --muted: 211, 76%, 8%;\n    --muted-foreground: 200 46% 65%;\n    --accent: 217 79% 24%;\n    --accent-foreground: 0 0% 98%;\n    --destructive: 0 62.8% 30.6%;\n    --destructive-foreground: 0 0% 98%;\n    --border: 0 0% 14.9%;\n    --input: 236 52% 30%;\n    --ring: 214 98% 60%;\n    --chart-1: 220 70% 50%;\n    --chart-2: 160 60% 45%;\n    --chart-3: 30 80% 55%;\n    --chart-4: 280 65% 60%;\n    --chart-5: 340 75% 55%;\n    --radius: 0.5rem;\n    --success-bg: hsl(143, 85%, 96%);\n    --success-border: hsl(145, 92%, 91%);\n    --success-text: hsl(140, 100%, 27%);\n\n    --info-bg: hsl(208, 100%, 97%);\n    --info-border: hsl(221, 91%, 91%);\n    --info-text: hsl(210, 92%, 45%);\n\n    --warning-bg: hsl(49, 100%, 97%);\n    --warning-border: hsl(49, 91%, 91%);\n    --warning-text: hsl(31, 92%, 45%);\n\n    --error-bg: hsl(359, 100%, 97%);\n    --error-border: hsl(359, 100%, 94%);\n    --error-text: hsl(360, 100%, 45%);\n  }\n\n  .dark {\n    --background: 0 0% 3.9%;\n    --foreground: 0 0% 98%;\n    --card: 234 64% 10%;\n    --card-foreground: 0 0% 98%;\n    --popover: 0 0% 3.9%;\n    --popover-foreground: 0 0% 98%;\n    --primary: 211, 77%, 68%;\n    --primary-foreground: 0 0% 98%;\n    --secondary: 0 0% 14.9%;\n    --secondary-foreground: 0 0% 98%;\n    --muted: 0 0% 14.9%;\n    --muted-foreground: 0 0% 63.9%;\n    --accent: 0 0% 14.9%;\n    --accent-foreground: 0 0% 98%;\n    --destructive: 0 62.8% 30.6%;\n    --destructive-foreground: 0 0% 98%;\n    --border: 0 0% 14.9%;\n    --input: 236 52% 30%;\n    --ring: 214 98% 60%;\n    --chart-1: 220 70% 50%;\n    --chart-2: 160 60% 45%;\n    --chart-3: 30 80% 55%;\n    --chart-4: 280 65% 60%;\n    --chart-5: 340 75% 55%;\n  }\n}\n\n/* ORIGINAL THEME for comparison and testing\n\n@layer base {\n  :root {\n    --background: 0 0% 100%;\n    --foreground: 240 10% 3.9%;\n    --card: 0 0% 100%;\n    --card-foreground: 240 10% 3.9%;\n    --popover: 0 0% 100%;\n    --popover-foreground: 240 10% 3.9%;\n    --primary: 240 5.9% 10%;\n    --primary-foreground: 0 0% 98%;\n    --secondary: 240 4.8% 95.9%;\n    --secondary-foreground: 240 5.9% 10%;\n    --muted: 240 4.8% 95.9%;\n    --muted-foreground: 240 3.8% 46.1%;\n    --accent: 240 4.8% 95.9%;\n    --accent-foreground: 240 5.9% 10%;\n    --destructive: 0 72.22% 50.59%;\n    --destructive-foreground: 0 0% 98%;\n    --border: 240 5.9% 90%;\n    --input: 240 5.9% 90%;\n    --ring: 240 5% 64.9%;\n    --radius: 0.5rem;\n\n    --chart-1: 12 76% 61%;\n    --chart-2: 173 58% 39%;\n    --chart-3: 197 37% 24%;\n    --chart-4: 43 74% 66%;\n    --chart-5: 27 87% 67%;\n  }\n\n\n  .dark {\n    --background: 240 10% 3.9%;\n    --foreground: 0 0% 98%;\n    --card: 240 10% 3.9%;\n    --card-foreground: 0 0% 98%;\n    --popover: 240 10% 3.9%;\n    --popover-foreground: 0 0% 98%;\n    --primary: 0 0% 98%;\n    --primary-foreground: 240 5.9% 10%;\n    --secondary: 240 3.7% 15.9%;\n    --secondary-foreground: 0 0% 98%;\n    --muted: 240 3.7% 15.9%;\n    --muted-foreground: 240 5% 64.9%;\n    --accent: 240 3.7% 15.9%;\n    --accent-foreground: 0 0% 98%;\n    --destructive: 0 62.8% 30.6%;\n    --destructive-foreground: 0 85.7% 97.3%;\n    --border: 240 3.7% 15.9%;\n    --input: 240 3.7% 15.9%;\n    --ring: 240 4.9% 83.9%;\n\n    --chart-1: 220 70% 50%;\n    --chart-2: 160 60% 45%;\n    --chart-3: 30 80% 55%;\n    --chart-4: 280 65% 60%;\n    --chart-5: 340 75% 55%;\n  }\n}\n\n*/\n\n/* Theme Copy Example\n\n@layer base {\n  :root {\n    --background: 0 0% 100%;\n    --foreground: 224 71.4% 4.1%;\n    --card: 0 0% 100%;\n    --card-foreground: 224 71.4% 4.1%;\n    --popover: 0 0% 100%;\n    --popover-foreground: 224 71.4% 4.1%;\n    --primary: 262.1 83.3% 57.8%;\n    --primary-foreground: 210 20% 98%;\n    --secondary: 220 14.3% 95.9%;\n    --secondary-foreground: 220.9 39.3% 11%;\n    --muted: 220 14.3% 95.9%;\n    --muted-foreground: 220 8.9% 46.1%;\n    --accent: 220 14.3% 95.9%;\n    --accent-foreground: 220.9 39.3% 11%;\n    --destructive: 360 84.2% 60.2%;\n    --destructive-foreground: 210 20% 98%;\n    --border: 220 13% 91%;\n    --input: 220 13% 91%;\n    --ring: 262.1 83.3% 57.8%;\n    --radius: 0.5rem;\n    --chart-1: ;\n    --chart-2: ;\n    --chart-3: ;\n    --chart-4: ;\n    --chart-5: ;\n  }\n\n  .dark {\n    --background: 224 71.4% 4.1%;\n    --foreground: 210 20% 98%;\n    --card: 224 71.4% 4.1%;\n    --card-foreground: 210 20% 98%;\n    --popover: 224 71.4% 4.1%;\n    --popover-foreground: 210 20% 98%;\n    --primary: 263.4 70% 50.4%;\n    --primary-foreground: 210 20% 98%;\n    --secondary: 215 27.9% 16.9%;\n    --secondary-foreground: 210 20% 98%;\n    --muted: 215 27.9% 16.9%;\n    --muted-foreground: 217.9 10.6% 64.9%;\n    --accent: 215 27.9% 16.9%;\n    --accent-foreground: 210 20% 98%;\n    --destructive: 360 84.2% 60.2%;\n    --destructive-foreground: 210 20% 98%;\n    --border: 215 27.9% 16.9%;\n    --input: 215 27.9% 16.9%;\n    --ring: 263.4 70% 50.4%;\n    --chart-1: ;\n    --chart-2: ;\n    --chart-3: ;\n    --chart-4: ;\n    --chart-5: ;\n  }\n}\n\n*/\n\n/* Updated Playground page styles */\n\n@layer base {\n  html {\n    font-family: 'Inter', sans-serif;\n  }\n\n  body {\n    @apply !bg-black;\n  }\n}\n\nh2.section-header {\n  @apply py-4 text-2xl font-normal text-white;\n}\n\nh3.section-header {\n  @apply py-3 text-xl text-white;\n}\n\n.row {\n  @apply mb-6 flex flex-row flex-wrap rounded-md border py-10;\n}\n\n.example {\n  @apply flex-initial px-6;\n}\n\n.example2 {\n  @apply flex-initial px-4;\n}\n\n/* Additional CSS edits to components */\n\n/* Tooltip */\n\n.TooltipContent[data-side='bottom'] {\n  animation-name: slideDown;\n}\n\n/* Custom CSS to hide default number input arrows */\ninput[type='number']::-webkit-inner-spin-button,\ninput[type='number']::-webkit-outer-spin-button {\n  @apply appearance-none;\n}\n\ninput[type='number'] {\n  -moz-appearance: textfield; /* For Firefox */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
